var fr = Object.defineProperty;
var s = (e, t) => fr(e, "name", { value: t, configurable: !0 });
var mr = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports);

// (disabled):../node_modules/util/util.js
var _n = mr(() => {
});

// src/instrumenter/instrumenter.ts
import { once as Ki } from "storybook/internal/client-logger";
import {
  FORCE_REMOUNT as sr,
  SET_CURRENT_STORY as Gi,
  STORY_RENDER_PHASE_CHANGED as Hi
} from "storybook/internal/core-events";
import { global as U } from "@storybook/global";

// ../node_modules/tinyrainbow/dist/chunk-BVHSVHOK.js
var pr = {
  reset: [0, 0],
  bold: [1, 22, "\x1B[22m\x1B[1m"],
  dim: [2, 22, "\x1B[22m\x1B[2m"],
  italic: [3, 23],
  underline: [4, 24],
  inverse: [7, 27],
  hidden: [8, 28],
  strikethrough: [9, 29],
  black: [30, 39],
  red: [31, 39],
  green: [32, 39],
  yellow: [33, 39],
  blue: [34, 39],
  magenta: [35, 39],
  cyan: [36, 39],
  white: [37, 39],
  gray: [90, 39],
  bgBlack: [40, 49],
  bgRed: [41, 49],
  bgGreen: [42, 49],
  bgYellow: [43, 49],
  bgBlue: [44, 49],
  bgMagenta: [45, 49],
  bgCyan: [46, 49],
  bgWhite: [47, 49],
  blackBright: [90, 39],
  redBright: [91, 39],
  greenBright: [92, 39],
  yellowBright: [93, 39],
  blueBright: [94, 39],
  magentaBright: [95, 39],
  cyanBright: [96, 39],
  whiteBright: [97, 39],
  bgBlackBright: [100, 49],
  bgRedBright: [101, 49],
  bgGreenBright: [102, 49],
  bgYellowBright: [103, 49],
  bgBlueBright: [104, 49],
  bgMagentaBright: [105, 49],
  bgCyanBright: [106, 49],
  bgWhiteBright: [107, 49]
}, gr = Object.entries(pr);
function Ge(e) {
  return String(e);
}
s(Ge, "a");
Ge.open = "";
Ge.close = "";
function Dt(e = !1) {
  let t = typeof process < "u" ? process : void 0, n = t?.env || {}, r = t?.argv || [];
  return !("NO_COLOR" in n || r.includes("--no-color")) && ("FORCE_COLOR" in n || r.includes("--color") || t?.platform === "win32" || e && n.
  TERM !== "dumb" || "CI" in n) || typeof window < "u" && !!window.chrome;
}
s(Dt, "C");
function Ft(e = !1) {
  let t = Dt(e), n = /* @__PURE__ */ s((c, l, u, m) => {
    let p = "", a = 0;
    do
      p += c.substring(a, m) + u, a = m + l.length, m = c.indexOf(l, a);
    while (~m);
    return p + c.substring(a);
  }, "i"), r = /* @__PURE__ */ s((c, l, u = c) => {
    let m = /* @__PURE__ */ s((p) => {
      let a = String(p), S = a.indexOf(l, c.length);
      return ~S ? c + n(a, l, u, S) + l : c + a + l;
    }, "o");
    return m.open = c, m.close = l, m;
  }, "g"), o = {
    isColorSupported: t
  }, i = /* @__PURE__ */ s((c) => `\x1B[${c}m`, "d");
  for (let [c, l] of gr)
    o[c] = t ? r(
      i(l[0]),
      i(l[1]),
      l[2]
    ) : Ge;
  return o;
}
s(Ft, "p");

// ../node_modules/tinyrainbow/dist/browser.js
var v = Ft();

// ../node_modules/@vitest/pretty-format/dist/index.js
function Jt(e, t) {
  return t.forEach(function(n) {
    n && typeof n != "string" && !Array.isArray(n) && Object.keys(n).forEach(function(r) {
      if (r !== "default" && !(r in e)) {
        var o = Object.getOwnPropertyDescriptor(n, r);
        Object.defineProperty(e, r, o.get ? o : {
          enumerable: !0,
          get: /* @__PURE__ */ s(function() {
            return n[r];
          }, "get")
        });
      }
    });
  }), Object.freeze(e);
}
s(Jt, "_mergeNamespaces");
function hr(e, t) {
  let n = Object.keys(e), r = t === null ? n : n.sort(t);
  if (Object.getOwnPropertySymbols)
    for (let o of Object.getOwnPropertySymbols(e))
      Object.getOwnPropertyDescriptor(e, o).enumerable && r.push(o);
  return r;
}
s(hr, "getKeysOfEnumerableProperties");
function _e(e, t, n, r, o, i, c = ": ") {
  let l = "", u = 0, m = e.next();
  if (!m.done) {
    l += t.spacingOuter;
    let p = n + t.indent;
    for (; !m.done; ) {
      if (l += p, u++ === t.maxWidth) {
        l += "\u2026";
        break;
      }
      let a = i(m.value[0], t, p, r, o), S = i(m.value[1], t, p, r, o);
      l += a + c + S, m = e.next(), m.done ? t.min || (l += ",") : l += `,${t.spacingInner}`;
    }
    l += t.spacingOuter + n;
  }
  return l;
}
s(_e, "printIteratorEntries");
function Qe(e, t, n, r, o, i) {
  let c = "", l = 0, u = e.next();
  if (!u.done) {
    c += t.spacingOuter;
    let m = n + t.indent;
    for (; !u.done; ) {
      if (c += m, l++ === t.maxWidth) {
        c += "\u2026";
        break;
      }
      c += i(u.value, t, m, r, o), u = e.next(), u.done ? t.min || (c += ",") : c += `,${t.spacingInner}`;
    }
    c += t.spacingOuter + n;
  }
  return c;
}
s(Qe, "printIteratorValues");
function Ne(e, t, n, r, o, i) {
  let c = "";
  e = e instanceof ArrayBuffer ? new DataView(e) : e;
  let l = /* @__PURE__ */ s((m) => m instanceof DataView, "isDataView"), u = l(e) ? e.byteLength : e.length;
  if (u > 0) {
    c += t.spacingOuter;
    let m = n + t.indent;
    for (let p = 0; p < u; p++) {
      if (c += m, p === t.maxWidth) {
        c += "\u2026";
        break;
      }
      (l(e) || p in e) && (c += i(l(e) ? e.getInt8(p) : e[p], t, m, r, o)), p < u - 1 ? c += `,${t.spacingInner}` : t.min || (c += ",");
    }
    c += t.spacingOuter + n;
  }
  return c;
}
s(Ne, "printListItems");
function ve(e, t, n, r, o, i) {
  let c = "", l = hr(e, t.compareKeys);
  if (l.length > 0) {
    c += t.spacingOuter;
    let u = n + t.indent;
    for (let m = 0; m < l.length; m++) {
      let p = l[m], a = i(p, t, u, r, o), S = i(e[p], t, u, r, o);
      c += `${u + a}: ${S}`, m < l.length - 1 ? c += `,${t.spacingInner}` : t.min || (c += ",");
    }
    c += t.spacingOuter + n;
  }
  return c;
}
s(ve, "printObjectProperties");
var yr = typeof Symbol == "function" && Symbol.for ? Symbol.for("jest.asymmetricMatcher") : 1267621, Ae = " ", dr = /* @__PURE__ */ s((e, t, n, r, o, i) => {
  let c = e.toString();
  if (c === "ArrayContaining" || c === "ArrayNotContaining")
    return ++r > t.maxDepth ? `[${c}]` : `${c + Ae}[${Ne(e.sample, t, n, r, o, i)}]`;
  if (c === "ObjectContaining" || c === "ObjectNotContaining")
    return ++r > t.maxDepth ? `[${c}]` : `${c + Ae}{${ve(e.sample, t, n, r, o, i)}}`;
  if (c === "StringMatching" || c === "StringNotMatching" || c === "StringContaining" || c === "StringNotContaining")
    return c + Ae + i(e.sample, t, n, r, o);
  if (typeof e.toAsymmetricMatcher != "function")
    throw new TypeError(`Asymmetric matcher ${e.constructor.name} does not implement toAsymmetricMatcher()`);
  return e.toAsymmetricMatcher();
}, "serialize$5"), br = /* @__PURE__ */ s((e) => e && e.$$typeof === yr, "test$5"), Sr = {
  serialize: dr,
  test: br
}, Er = " ", Xt = /* @__PURE__ */ new Set(["DOMStringMap", "NamedNodeMap"]), _r = /^(?:HTML\w*Collection|NodeList)$/;
function Tr(e) {
  return Xt.has(e) || _r.test(e);
}
s(Tr, "testName");
var Cr = /* @__PURE__ */ s((e) => e && e.constructor && !!e.constructor.name && Tr(e.constructor.name), "test$4");
function Or(e) {
  return e.constructor.name === "NamedNodeMap";
}
s(Or, "isNamedNodeMap");
var $r = /* @__PURE__ */ s((e, t, n, r, o, i) => {
  let c = e.constructor.name;
  return ++r > t.maxDepth ? `[${c}]` : (t.min ? "" : c + Er) + (Xt.has(c) ? `{${ve(Or(e) ? [...e].reduce((l, u) => (l[u.name] = u.value, l),
  {}) : { ...e }, t, n, r, o, i)}}` : `[${Ne([...e], t, n, r, o, i)}]`);
}, "serialize$4"), wr = {
  serialize: $r,
  test: Cr
};
function Zt(e) {
  return e.replaceAll("<", "&lt;").replaceAll(">", "&gt;");
}
s(Zt, "escapeHTML");
function et(e, t, n, r, o, i, c) {
  let l = r + n.indent, u = n.colors;
  return e.map((m) => {
    let p = t[m], a = c(p, n, l, o, i);
    return typeof p != "string" && (a.includes(`
`) && (a = n.spacingOuter + l + a + n.spacingOuter + r), a = `{${a}}`), `${n.spacingInner + r + u.prop.open + m + u.prop.close}=${u.value.open}${a}${u.
    value.close}`;
  }).join("");
}
s(et, "printProps");
function tt(e, t, n, r, o, i) {
  return e.map((c) => t.spacingOuter + n + (typeof c == "string" ? Qt(c, t) : i(c, t, n, r, o))).join("");
}
s(tt, "printChildren");
function Qt(e, t) {
  let n = t.colors.content;
  return n.open + Zt(e) + n.close;
}
s(Qt, "printText");
function Ar(e, t) {
  let n = t.colors.comment;
  return `${n.open}<!--${Zt(e)}-->${n.close}`;
}
s(Ar, "printComment");
function nt(e, t, n, r, o) {
  let i = r.colors.tag;
  return `${i.open}<${e}${t && i.close + t + r.spacingOuter + o + i.open}${n ? `>${i.close}${n}${r.spacingOuter}${o}${i.open}</${e}` : `${t &&
  !r.min ? "" : " "}/`}>${i.close}`;
}
s(nt, "printElement");
function rt(e, t) {
  let n = t.colors.tag;
  return `${n.open}<${e}${n.close} \u2026${n.open} />${n.close}`;
}
s(rt, "printElementAsLeaf");
var Rr = 1, vt = 3, en = 8, tn = 11, Nr = /^(?:(?:HTML|SVG)\w*)?Element$/;
function Ir(e) {
  try {
    return typeof e.hasAttribute == "function" && e.hasAttribute("is");
  } catch {
    return !1;
  }
}
s(Ir, "testHasAttribute");
function Pr(e) {
  let t = e.constructor.name, { nodeType: n, tagName: r } = e, o = typeof r == "string" && r.includes("-") || Ir(e);
  return n === Rr && (Nr.test(t) || o) || n === vt && t === "Text" || n === en && t === "Comment" || n === tn && t === "DocumentFragment";
}
s(Pr, "testNode");
var Mr = /* @__PURE__ */ s((e) => {
  var t;
  return (e == null || (t = e.constructor) === null || t === void 0 ? void 0 : t.name) && Pr(e);
}, "test$3");
function Lr(e) {
  return e.nodeType === vt;
}
s(Lr, "nodeIsText");
function xr(e) {
  return e.nodeType === en;
}
s(xr, "nodeIsComment");
function He(e) {
  return e.nodeType === tn;
}
s(He, "nodeIsFragment");
var Dr = /* @__PURE__ */ s((e, t, n, r, o, i) => {
  if (Lr(e))
    return Qt(e.data, t);
  if (xr(e))
    return Ar(e.data, t);
  let c = He(e) ? "DocumentFragment" : e.tagName.toLowerCase();
  return ++r > t.maxDepth ? rt(c, t) : nt(c, et(He(e) ? [] : Array.from(e.attributes, (l) => l.name).sort(), He(e) ? {} : [...e.attributes].
  reduce((l, u) => (l[u.name] = u.value, l), {}), t, n + t.indent, r, o, i), tt(Array.prototype.slice.call(e.childNodes || e.children), t, n +
  t.indent, r, o, i), t, n);
}, "serialize$3"), Fr = {
  serialize: Dr,
  test: Mr
}, jr = "@@__IMMUTABLE_ITERABLE__@@", kr = "@@__IMMUTABLE_LIST__@@", Br = "@@__IMMUTABLE_KEYED__@@", zr = "@@__IMMUTABLE_MAP__@@", jt = "@@_\
_IMMUTABLE_ORDERED__@@", Yr = "@@__IMMUTABLE_RECORD__@@", Ur = "@@__IMMUTABLE_SEQ__@@", Wr = "@@__IMMUTABLE_SET__@@", Vr = "@@__IMMUTABLE_ST\
ACK__@@", he = /* @__PURE__ */ s((e) => `Immutable.${e}`, "getImmutableName"), Pe = /* @__PURE__ */ s((e) => `[${e}]`, "printAsLeaf"), Ee = "\
 ", kt = "\u2026";
function qr(e, t, n, r, o, i, c) {
  return ++r > t.maxDepth ? Pe(he(c)) : `${he(c) + Ee}{${_e(e.entries(), t, n, r, o, i)}}`;
}
s(qr, "printImmutableEntries");
function Kr(e) {
  let t = 0;
  return { next() {
    if (t < e._keys.length) {
      let n = e._keys[t++];
      return {
        done: !1,
        value: [n, e.get(n)]
      };
    }
    return {
      done: !0,
      value: void 0
    };
  } };
}
s(Kr, "getRecordEntries");
function Gr(e, t, n, r, o, i) {
  let c = he(e._name || "Record");
  return ++r > t.maxDepth ? Pe(c) : `${c + Ee}{${_e(Kr(e), t, n, r, o, i)}}`;
}
s(Gr, "printImmutableRecord");
function Hr(e, t, n, r, o, i) {
  let c = he("Seq");
  return ++r > t.maxDepth ? Pe(c) : e[Br] ? `${c + Ee}{${e._iter || e._object ? _e(e.entries(), t, n, r, o, i) : kt}}` : `${c + Ee}[${e._iter ||
  e._array || e._collection || e._iterable ? Qe(e.values(), t, n, r, o, i) : kt}]`;
}
s(Hr, "printImmutableSeq");
function Je(e, t, n, r, o, i, c) {
  return ++r > t.maxDepth ? Pe(he(c)) : `${he(c) + Ee}[${Qe(e.values(), t, n, r, o, i)}]`;
}
s(Je, "printImmutableValues");
var Jr = /* @__PURE__ */ s((e, t, n, r, o, i) => e[zr] ? qr(e, t, n, r, o, i, e[jt] ? "OrderedMap" : "Map") : e[kr] ? Je(e, t, n, r, o, i, "\
List") : e[Wr] ? Je(e, t, n, r, o, i, e[jt] ? "OrderedSet" : "Set") : e[Vr] ? Je(e, t, n, r, o, i, "Stack") : e[Ur] ? Hr(e, t, n, r, o, i) :
Gr(e, t, n, r, o, i), "serialize$2"), Xr = /* @__PURE__ */ s((e) => e && (e[jr] === !0 || e[Yr] === !0), "test$2"), Zr = {
  serialize: Jr,
  test: Xr
};
function nn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
s(nn, "getDefaultExportFromCjs");
var Xe = { exports: {} };
var R = {};
var Bt;
function Qr() {
  return Bt || (Bt = 1, function() {
    function e(f) {
      if (typeof f == "object" && f !== null) {
        var y = f.$$typeof;
        switch (y) {
          case t:
            switch (f = f.type, f) {
              case r:
              case i:
              case o:
              case m:
              case p:
              case g:
                return f;
              default:
                switch (f = f && f.$$typeof, f) {
                  case l:
                  case u:
                  case S:
                  case a:
                    return f;
                  case c:
                    return f;
                  default:
                    return y;
                }
            }
          case n:
            return y;
        }
      }
    }
    s(e, "typeOf");
    var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("reac\
t.strict_mode"), i = Symbol.for("react.profiler"), c = Symbol.for("react.consumer"), l = Symbol.for("react.context"), u = Symbol.for("react.\
forward_ref"), m = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), a = Symbol.for("react.memo"), S = Symbol.for("react.\
lazy"), g = Symbol.for("react.view_transition"), h = Symbol.for("react.client.reference");
    R.ContextConsumer = c, R.ContextProvider = l, R.Element = t, R.ForwardRef = u, R.Fragment = r, R.Lazy = S, R.Memo = a, R.Portal = n, R.Profiler =
    i, R.StrictMode = o, R.Suspense = m, R.SuspenseList = p, R.isContextConsumer = function(f) {
      return e(f) === c;
    }, R.isContextProvider = function(f) {
      return e(f) === l;
    }, R.isElement = function(f) {
      return typeof f == "object" && f !== null && f.$$typeof === t;
    }, R.isForwardRef = function(f) {
      return e(f) === u;
    }, R.isFragment = function(f) {
      return e(f) === r;
    }, R.isLazy = function(f) {
      return e(f) === S;
    }, R.isMemo = function(f) {
      return e(f) === a;
    }, R.isPortal = function(f) {
      return e(f) === n;
    }, R.isProfiler = function(f) {
      return e(f) === i;
    }, R.isStrictMode = function(f) {
      return e(f) === o;
    }, R.isSuspense = function(f) {
      return e(f) === m;
    }, R.isSuspenseList = function(f) {
      return e(f) === p;
    }, R.isValidElementType = function(f) {
      return typeof f == "string" || typeof f == "function" || f === r || f === i || f === o || f === m || f === p || typeof f == "object" &&
      f !== null && (f.$$typeof === S || f.$$typeof === a || f.$$typeof === l || f.$$typeof === c || f.$$typeof === u || f.$$typeof === h ||
      f.getModuleId !== void 0);
    }, R.typeOf = e;
  }()), R;
}
s(Qr, "requireReactIs_development$1");
var zt;
function vr() {
  return zt || (zt = 1, Xe.exports = Qr()), Xe.exports;
}
s(vr, "requireReactIs$1");
var rn = vr(), eo = /* @__PURE__ */ nn(rn), to = /* @__PURE__ */ Jt({
  __proto__: null,
  default: eo
}, [rn]), Ze = { exports: {} };
var w = {};
var Yt;
function no() {
  return Yt || (Yt = 1, function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"),
    o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), c = Symbol.for("react.context"), l = Symbol.for("react.server_contex\
t"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), a = Symbol.for("react.mem\
o"), S = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), h = !1, f = !1, y = !1, b = !1, _ = !1, O;
    O = Symbol.for("react.module.reference");
    function d(C) {
      return !!(typeof C == "string" || typeof C == "function" || C === n || C === o || _ || C === r || C === m || C === p || b || C === g ||
      h || f || y || typeof C == "object" && C !== null && (C.$$typeof === S || C.$$typeof === a || C.$$typeof === i || C.$$typeof === c || C.
      $$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      C.$$typeof === O || C.getModuleId !== void 0));
    }
    s(d, "isValidElementType");
    function E(C) {
      if (typeof C == "object" && C !== null) {
        var Ke = C.$$typeof;
        switch (Ke) {
          case e:
            var we = C.type;
            switch (we) {
              case n:
              case o:
              case r:
              case m:
              case p:
                return we;
              default:
                var xt = we && we.$$typeof;
                switch (xt) {
                  case l:
                  case c:
                  case u:
                  case S:
                  case a:
                  case i:
                    return xt;
                  default:
                    return Ke;
                }
            }
          case t:
            return Ke;
        }
      }
    }
    s(E, "typeOf");
    var $ = c, T = i, A = e, G = u, Q = n, P = S, k = a, H = t, Y = o, I = r, L = m, x = p, J = !1, F = !1;
    function V(C) {
      return J || (J = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    s(V, "isAsyncMode");
    function re(C) {
      return F || (F = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    s(re, "isConcurrentMode");
    function q(C) {
      return E(C) === c;
    }
    s(q, "isContextConsumer");
    function K(C) {
      return E(C) === i;
    }
    s(K, "isContextProvider");
    function ie(C) {
      return typeof C == "object" && C !== null && C.$$typeof === e;
    }
    s(ie, "isElement");
    function X(C) {
      return E(C) === u;
    }
    s(X, "isForwardRef");
    function W(C) {
      return E(C) === n;
    }
    s(W, "isFragment");
    function oe(C) {
      return E(C) === S;
    }
    s(oe, "isLazy");
    function ge(C) {
      return E(C) === a;
    }
    s(ge, "isMemo");
    function ue(C) {
      return E(C) === t;
    }
    s(ue, "isPortal");
    function Se(C) {
      return E(C) === o;
    }
    s(Se, "isProfiler");
    function Oe(C) {
      return E(C) === r;
    }
    s(Oe, "isStrictMode");
    function $e(C) {
      return E(C) === m;
    }
    s($e, "isSuspense");
    function ar(C) {
      return E(C) === p;
    }
    s(ar, "isSuspenseList"), w.ContextConsumer = $, w.ContextProvider = T, w.Element = A, w.ForwardRef = G, w.Fragment = Q, w.Lazy = P, w.Memo =
    k, w.Portal = H, w.Profiler = Y, w.StrictMode = I, w.Suspense = L, w.SuspenseList = x, w.isAsyncMode = V, w.isConcurrentMode = re, w.isContextConsumer =
    q, w.isContextProvider = K, w.isElement = ie, w.isForwardRef = X, w.isFragment = W, w.isLazy = oe, w.isMemo = ge, w.isPortal = ue, w.isProfiler =
    Se, w.isStrictMode = Oe, w.isSuspense = $e, w.isSuspenseList = ar, w.isValidElementType = d, w.typeOf = E;
  }()), w;
}
s(no, "requireReactIs_development");
var Ut;
function ro() {
  return Ut || (Ut = 1, Ze.exports = no()), Ze.exports;
}
s(ro, "requireReactIs");
var on = ro(), oo = /* @__PURE__ */ nn(on), io = /* @__PURE__ */ Jt({
  __proto__: null,
  default: oo
}, [on]), so = [
  "isAsyncMode",
  "isConcurrentMode",
  "isContextConsumer",
  "isContextProvider",
  "isElement",
  "isForwardRef",
  "isFragment",
  "isLazy",
  "isMemo",
  "isPortal",
  "isProfiler",
  "isStrictMode",
  "isSuspense",
  "isSuspenseList",
  "isValidElementType"
], ae = Object.fromEntries(so.map((e) => [e, (t) => io[e](t) || to[e](t)]));
function sn(e, t = []) {
  if (Array.isArray(e))
    for (let n of e)
      sn(n, t);
  else e != null && e !== !1 && e !== "" && t.push(e);
  return t;
}
s(sn, "getChildren");
function Wt(e) {
  let t = e.type;
  if (typeof t == "string")
    return t;
  if (typeof t == "function")
    return t.displayName || t.name || "Unknown";
  if (ae.isFragment(e))
    return "React.Fragment";
  if (ae.isSuspense(e))
    return "React.Suspense";
  if (typeof t == "object" && t !== null) {
    if (ae.isContextProvider(e))
      return "Context.Provider";
    if (ae.isContextConsumer(e))
      return "Context.Consumer";
    if (ae.isForwardRef(e)) {
      if (t.displayName)
        return t.displayName;
      let n = t.render.displayName || t.render.name || "";
      return n === "" ? "ForwardRef" : `ForwardRef(${n})`;
    }
    if (ae.isMemo(e)) {
      let n = t.displayName || t.type.displayName || t.type.name || "";
      return n === "" ? "Memo" : `Memo(${n})`;
    }
  }
  return "UNDEFINED";
}
s(Wt, "getType");
function co(e) {
  let { props: t } = e;
  return Object.keys(t).filter((n) => n !== "children" && t[n] !== void 0).sort();
}
s(co, "getPropKeys$1");
var uo = /* @__PURE__ */ s((e, t, n, r, o, i) => ++r > t.maxDepth ? rt(Wt(e), t) : nt(Wt(e), et(co(e), e.props, t, n + t.indent, r, o, i), tt(
sn(e.props.children), t, n + t.indent, r, o, i), t, n), "serialize$1"), lo = /* @__PURE__ */ s((e) => e != null && ae.isElement(e), "test$1"),
ao = {
  serialize: uo,
  test: lo
}, fo = typeof Symbol == "function" && Symbol.for ? Symbol.for("react.test.json") : 245830487;
function mo(e) {
  let { props: t } = e;
  return t ? Object.keys(t).filter((n) => t[n] !== void 0).sort() : [];
}
s(mo, "getPropKeys");
var po = /* @__PURE__ */ s((e, t, n, r, o, i) => ++r > t.maxDepth ? rt(e.type, t) : nt(e.type, e.props ? et(mo(e), e.props, t, n + t.indent,
r, o, i) : "", e.children ? tt(e.children, t, n + t.indent, r, o, i) : "", t, n), "serialize"), go = /* @__PURE__ */ s((e) => e && e.$$typeof ===
fo, "test"), ho = {
  serialize: po,
  test: go
}, cn = Object.prototype.toString, yo = Date.prototype.toISOString, bo = Error.prototype.toString, Vt = RegExp.prototype.toString;
function Re(e) {
  return typeof e.constructor == "function" && e.constructor.name || "Object";
}
s(Re, "getConstructorName");
function So(e) {
  return typeof window < "u" && e === window;
}
s(So, "isWindow");
var Eo = /^Symbol\((.*)\)(.*)$/, _o = /\n/g, it = class it extends Error {
  constructor(t, n) {
    super(t), this.stack = n, this.name = this.constructor.name;
  }
};
s(it, "PrettyFormatPluginError");
var Ie = it;
function To(e) {
  return e === "[object Array]" || e === "[object ArrayBuffer]" || e === "[object DataView]" || e === "[object Float32Array]" || e === "[obj\
ect Float64Array]" || e === "[object Int8Array]" || e === "[object Int16Array]" || e === "[object Int32Array]" || e === "[object Uint8Array]" ||
  e === "[object Uint8ClampedArray]" || e === "[object Uint16Array]" || e === "[object Uint32Array]";
}
s(To, "isToStringedArrayType");
function Co(e) {
  return Object.is(e, -0) ? "-0" : String(e);
}
s(Co, "printNumber");
function Oo(e) {
  return `${e}n`;
}
s(Oo, "printBigInt");
function qt(e, t) {
  return t ? `[Function ${e.name || "anonymous"}]` : "[Function]";
}
s(qt, "printFunction");
function Kt(e) {
  return String(e).replace(Eo, "Symbol($1)");
}
s(Kt, "printSymbol");
function Gt(e) {
  return `[${bo.call(e)}]`;
}
s(Gt, "printError");
function un(e, t, n, r) {
  if (e === !0 || e === !1)
    return `${e}`;
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  let o = typeof e;
  if (o === "number")
    return Co(e);
  if (o === "bigint")
    return Oo(e);
  if (o === "string")
    return r ? `"${e.replaceAll(/"|\\/g, "\\$&")}"` : `"${e}"`;
  if (o === "function")
    return qt(e, t);
  if (o === "symbol")
    return Kt(e);
  let i = cn.call(e);
  return i === "[object WeakMap]" ? "WeakMap {}" : i === "[object WeakSet]" ? "WeakSet {}" : i === "[object Function]" || i === "[object Gen\
eratorFunction]" ? qt(e, t) : i === "[object Symbol]" ? Kt(e) : i === "[object Date]" ? Number.isNaN(+e) ? "Date { NaN }" : yo.call(e) : i ===
  "[object Error]" ? Gt(e) : i === "[object RegExp]" ? n ? Vt.call(e).replaceAll(/[$()*+.?[\\\]^{|}]/g, "\\$&") : Vt.call(e) : e instanceof Error ?
  Gt(e) : null;
}
s(un, "printBasicValue");
function ln(e, t, n, r, o, i) {
  if (o.includes(e))
    return "[Circular]";
  o = [...o], o.push(e);
  let c = ++r > t.maxDepth, l = t.min;
  if (t.callToJSON && !c && e.toJSON && typeof e.toJSON == "function" && !i)
    return le(e.toJSON(), t, n, r, o, !0);
  let u = cn.call(e);
  return u === "[object Arguments]" ? c ? "[Arguments]" : `${l ? "" : "Arguments "}[${Ne(e, t, n, r, o, le)}]` : To(u) ? c ? `[${e.constructor.
  name}]` : `${l || !t.printBasicPrototype && e.constructor.name === "Array" ? "" : `${e.constructor.name} `}[${Ne(e, t, n, r, o, le)}]` : u ===
  "[object Map]" ? c ? "[Map]" : `Map {${_e(e.entries(), t, n, r, o, le, " => ")}}` : u === "[object Set]" ? c ? "[Set]" : `Set {${Qe(e.values(),
  t, n, r, o, le)}}` : c || So(e) ? `[${Re(e)}]` : `${l || !t.printBasicPrototype && Re(e) === "Object" ? "" : `${Re(e)} `}{${ve(e, t, n, r,
  o, le)}}`;
}
s(ln, "printComplexValue");
var $o = {
  test: /* @__PURE__ */ s((e) => e && e instanceof Error, "test"),
  serialize(e, t, n, r, o, i) {
    if (o.includes(e))
      return "[Circular]";
    o = [...o, e];
    let c = ++r > t.maxDepth, { message: l, cause: u, ...m } = e, p = {
      message: l,
      ...typeof u < "u" ? { cause: u } : {},
      ...e instanceof AggregateError ? { errors: e.errors } : {},
      ...m
    }, a = e.name !== "Error" ? e.name : Re(e);
    return c ? `[${a}]` : `${a} {${_e(Object.entries(p).values(), t, n, r, o, i)}}`;
  }
};
function wo(e) {
  return e.serialize != null;
}
s(wo, "isNewPlugin");
function an(e, t, n, r, o, i) {
  let c;
  try {
    c = wo(e) ? e.serialize(t, n, r, o, i, le) : e.print(t, (l) => le(l, n, r, o, i), (l) => {
      let u = r + n.indent;
      return u + l.replaceAll(_o, `
${u}`);
    }, {
      edgeSpacing: n.spacingOuter,
      min: n.min,
      spacing: n.spacingInner
    }, n.colors);
  } catch (l) {
    throw new Ie(l.message, l.stack);
  }
  if (typeof c != "string")
    throw new TypeError(`pretty-format: Plugin must return type "string" but instead returned "${typeof c}".`);
  return c;
}
s(an, "printPlugin");
function fn(e, t) {
  for (let n of e)
    try {
      if (n.test(t))
        return n;
    } catch (r) {
      throw new Ie(r.message, r.stack);
    }
  return null;
}
s(fn, "findPlugin");
function le(e, t, n, r, o, i) {
  let c = fn(t.plugins, e);
  if (c !== null)
    return an(c, e, t, n, r, o);
  let l = un(e, t.printFunctionName, t.escapeRegex, t.escapeString);
  return l !== null ? l : ln(e, t, n, r, o, i);
}
s(le, "printer");
var ot = {
  comment: "gray",
  content: "reset",
  prop: "yellow",
  tag: "cyan",
  value: "green"
}, mn = Object.keys(ot), ee = {
  callToJSON: !0,
  compareKeys: void 0,
  escapeRegex: !1,
  escapeString: !0,
  highlight: !1,
  indent: 2,
  maxDepth: Number.POSITIVE_INFINITY,
  maxWidth: Number.POSITIVE_INFINITY,
  min: !1,
  plugins: [],
  printBasicPrototype: !0,
  printFunctionName: !0,
  theme: ot
};
function Ao(e) {
  for (let t of Object.keys(e))
    if (!Object.prototype.hasOwnProperty.call(ee, t))
      throw new Error(`pretty-format: Unknown option "${t}".`);
  if (e.min && e.indent !== void 0 && e.indent !== 0)
    throw new Error('pretty-format: Options "min" and "indent" cannot be used together.');
}
s(Ao, "validateOptions");
function Ro() {
  return mn.reduce((e, t) => {
    let n = ot[t], r = n && v[n];
    if (r && typeof r.close == "string" && typeof r.open == "string")
      e[t] = r;
    else
      throw new Error(`pretty-format: Option "theme" has a key "${t}" whose value "${n}" is undefined in ansi-styles.`);
    return e;
  }, /* @__PURE__ */ Object.create(null));
}
s(Ro, "getColorsHighlight");
function No() {
  return mn.reduce((e, t) => (e[t] = {
    close: "",
    open: ""
  }, e), /* @__PURE__ */ Object.create(null));
}
s(No, "getColorsEmpty");
function pn(e) {
  return e?.printFunctionName ?? ee.printFunctionName;
}
s(pn, "getPrintFunctionName");
function gn(e) {
  return e?.escapeRegex ?? ee.escapeRegex;
}
s(gn, "getEscapeRegex");
function hn(e) {
  return e?.escapeString ?? ee.escapeString;
}
s(hn, "getEscapeString");
function Ht(e) {
  return {
    callToJSON: e?.callToJSON ?? ee.callToJSON,
    colors: e?.highlight ? Ro() : No(),
    compareKeys: typeof e?.compareKeys == "function" || e?.compareKeys === null ? e.compareKeys : ee.compareKeys,
    escapeRegex: gn(e),
    escapeString: hn(e),
    indent: e?.min ? "" : Io(e?.indent ?? ee.indent),
    maxDepth: e?.maxDepth ?? ee.maxDepth,
    maxWidth: e?.maxWidth ?? ee.maxWidth,
    min: e?.min ?? ee.min,
    plugins: e?.plugins ?? ee.plugins,
    printBasicPrototype: e?.printBasicPrototype ?? !0,
    printFunctionName: pn(e),
    spacingInner: e?.min ? " " : `
`,
    spacingOuter: e?.min ? "" : `
`
  };
}
s(Ht, "getConfig");
function Io(e) {
  return Array.from({ length: e + 1 }).join(" ");
}
s(Io, "createIndent");
function Z(e, t) {
  if (t && (Ao(t), t.plugins)) {
    let r = fn(t.plugins, e);
    if (r !== null)
      return an(r, e, Ht(t), "", 0, []);
  }
  let n = un(e, pn(t), gn(t), hn(t));
  return n !== null ? n : ln(e, Ht(t), "", 0, []);
}
s(Z, "format");
var Te = {
  AsymmetricMatcher: Sr,
  DOMCollection: wr,
  DOMElement: Fr,
  Immutable: Zr,
  ReactElement: ao,
  ReactTestComponent: ho,
  Error: $o
};

// ../node_modules/loupe/lib/helpers.js
var yn = {
  bold: ["1", "22"],
  dim: ["2", "22"],
  italic: ["3", "23"],
  underline: ["4", "24"],
  // 5 & 6 are blinking
  inverse: ["7", "27"],
  hidden: ["8", "28"],
  strike: ["9", "29"],
  // 10-20 are fonts
  // 21-29 are resets for 1-9
  black: ["30", "39"],
  red: ["31", "39"],
  green: ["32", "39"],
  yellow: ["33", "39"],
  blue: ["34", "39"],
  magenta: ["35", "39"],
  cyan: ["36", "39"],
  white: ["37", "39"],
  brightblack: ["30;1", "39"],
  brightred: ["31;1", "39"],
  brightgreen: ["32;1", "39"],
  brightyellow: ["33;1", "39"],
  brightblue: ["34;1", "39"],
  brightmagenta: ["35;1", "39"],
  brightcyan: ["36;1", "39"],
  brightwhite: ["37;1", "39"],
  grey: ["90", "39"]
}, Po = {
  special: "cyan",
  number: "yellow",
  bigint: "yellow",
  boolean: "yellow",
  undefined: "grey",
  null: "bold",
  string: "green",
  symbol: "green",
  date: "magenta",
  regexp: "red"
}, se = "\u2026";
function Mo(e, t) {
  let n = yn[Po[t]] || yn[t] || "";
  return n ? `\x1B[${n[0]}m${String(e)}\x1B[${n[1]}m` : String(e);
}
s(Mo, "colorise");
function dn({
  showHidden: e = !1,
  depth: t = 2,
  colors: n = !1,
  customInspect: r = !0,
  showProxy: o = !1,
  maxArrayLength: i = 1 / 0,
  breakLength: c = 1 / 0,
  seen: l = [],
  // eslint-disable-next-line no-shadow
  truncate: u = 1 / 0,
  stylize: m = String
} = {}, p) {
  let a = {
    showHidden: !!e,
    depth: Number(t),
    colors: !!n,
    customInspect: !!r,
    showProxy: !!o,
    maxArrayLength: Number(i),
    breakLength: Number(c),
    truncate: Number(u),
    seen: l,
    inspect: p,
    stylize: m
  };
  return a.colors && (a.stylize = Mo), a;
}
s(dn, "normaliseOptions");
function Lo(e) {
  return e >= "\uD800" && e <= "\uDBFF";
}
s(Lo, "isHighSurrogate");
function B(e, t, n = se) {
  e = String(e);
  let r = n.length, o = e.length;
  if (r > t && o > r)
    return n;
  if (o > t && o > r) {
    let i = t - r;
    return i > 0 && Lo(e[i - 1]) && (i = i - 1), `${e.slice(0, i)}${n}`;
  }
  return e;
}
s(B, "truncate");
function D(e, t, n, r = ", ") {
  n = n || t.inspect;
  let o = e.length;
  if (o === 0)
    return "";
  let i = t.truncate, c = "", l = "", u = "";
  for (let m = 0; m < o; m += 1) {
    let p = m + 1 === e.length, a = m + 2 === e.length;
    u = `${se}(${e.length - m})`;
    let S = e[m];
    t.truncate = i - c.length - (p ? 0 : r.length);
    let g = l || n(S, t) + (p ? "" : r), h = c.length + g.length, f = h + u.length;
    if (p && h > i && c.length + u.length <= i || !p && !a && f > i || (l = p ? "" : n(e[m + 1], t) + (a ? "" : r), !p && a && f > i && h + l.
    length > i))
      break;
    if (c += g, !p && !a && h + l.length >= i) {
      u = `${se}(${e.length - m - 1})`;
      break;
    }
    u = "";
  }
  return `${c}${u}`;
}
s(D, "inspectList");
function xo(e) {
  return e.match(/^[a-zA-Z_][a-zA-Z_0-9]*$/) ? e : JSON.stringify(e).replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
}
s(xo, "quoteComplexKey");
function ce([e, t], n) {
  return n.truncate -= 2, typeof e == "string" ? e = xo(e) : typeof e != "number" && (e = `[${n.inspect(e, n)}]`), n.truncate -= e.length, t =
  n.inspect(t, n), `${e}: ${t}`;
}
s(ce, "inspectProperty");

// ../node_modules/loupe/lib/array.js
function st(e, t) {
  let n = Object.keys(e).slice(e.length);
  if (!e.length && !n.length)
    return "[]";
  t.truncate -= 4;
  let r = D(e, t);
  t.truncate -= r.length;
  let o = "";
  return n.length && (o = D(n.map((i) => [i, e[i]]), t, ce)), `[ ${r}${o ? `, ${o}` : ""} ]`;
}
s(st, "inspectArray");

// ../node_modules/loupe/lib/typedarray.js
var Do = /* @__PURE__ */ s((e) => typeof Buffer == "function" && e instanceof Buffer ? "Buffer" : e[Symbol.toStringTag] ? e[Symbol.toStringTag] :
e.constructor.name, "getArrayName");
function te(e, t) {
  let n = Do(e);
  t.truncate -= n.length + 4;
  let r = Object.keys(e).slice(e.length);
  if (!e.length && !r.length)
    return `${n}[]`;
  let o = "";
  for (let c = 0; c < e.length; c++) {
    let l = `${t.stylize(B(e[c], t.truncate), "number")}${c === e.length - 1 ? "" : ", "}`;
    if (t.truncate -= l.length, e[c] !== e.length && t.truncate <= 3) {
      o += `${se}(${e.length - e[c] + 1})`;
      break;
    }
    o += l;
  }
  let i = "";
  return r.length && (i = D(r.map((c) => [c, e[c]]), t, ce)), `${n}[ ${o}${i ? `, ${i}` : ""} ]`;
}
s(te, "inspectTypedArray");

// ../node_modules/loupe/lib/date.js
function ct(e, t) {
  let n = e.toJSON();
  if (n === null)
    return "Invalid Date";
  let r = n.split("T"), o = r[0];
  return t.stylize(`${o}T${B(r[1], t.truncate - o.length - 1)}`, "date");
}
s(ct, "inspectDate");

// ../node_modules/loupe/lib/function.js
function Me(e, t) {
  let n = e[Symbol.toStringTag] || "Function", r = e.name;
  return r ? t.stylize(`[${n} ${B(r, t.truncate - 11)}]`, "special") : t.stylize(`[${n}]`, "special");
}
s(Me, "inspectFunction");

// ../node_modules/loupe/lib/map.js
function Fo([e, t], n) {
  return n.truncate -= 4, e = n.inspect(e, n), n.truncate -= e.length, t = n.inspect(t, n), `${e} => ${t}`;
}
s(Fo, "inspectMapEntry");
function jo(e) {
  let t = [];
  return e.forEach((n, r) => {
    t.push([r, n]);
  }), t;
}
s(jo, "mapToEntries");
function ut(e, t) {
  return e.size === 0 ? "Map{}" : (t.truncate -= 7, `Map{ ${D(jo(e), t, Fo)} }`);
}
s(ut, "inspectMap");

// ../node_modules/loupe/lib/number.js
var ko = Number.isNaN || ((e) => e !== e);
function Le(e, t) {
  return ko(e) ? t.stylize("NaN", "number") : e === 1 / 0 ? t.stylize("Infinity", "number") : e === -1 / 0 ? t.stylize("-Infinity", "number") :
  e === 0 ? t.stylize(1 / e === 1 / 0 ? "+0" : "-0", "number") : t.stylize(B(String(e), t.truncate), "number");
}
s(Le, "inspectNumber");

// ../node_modules/loupe/lib/bigint.js
function xe(e, t) {
  let n = B(e.toString(), t.truncate - 1);
  return n !== se && (n += "n"), t.stylize(n, "bigint");
}
s(xe, "inspectBigInt");

// ../node_modules/loupe/lib/regexp.js
function lt(e, t) {
  let n = e.toString().split("/")[2], r = t.truncate - (2 + n.length), o = e.source;
  return t.stylize(`/${B(o, r)}/${n}`, "regexp");
}
s(lt, "inspectRegExp");

// ../node_modules/loupe/lib/set.js
function Bo(e) {
  let t = [];
  return e.forEach((n) => {
    t.push(n);
  }), t;
}
s(Bo, "arrayFromSet");
function at(e, t) {
  return e.size === 0 ? "Set{}" : (t.truncate -= 7, `Set{ ${D(Bo(e), t)} }`);
}
s(at, "inspectSet");

// ../node_modules/loupe/lib/string.js
var bn = new RegExp("['\\u0000-\\u001f\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\u\
ffff]", "g"), zo = {
  "\b": "\\b",
  "	": "\\t",
  "\n": "\\n",
  "\f": "\\f",
  "\r": "\\r",
  "'": "\\'",
  "\\": "\\\\"
}, Yo = 16, Uo = 4;
function Wo(e) {
  return zo[e] || `\\u${`0000${e.charCodeAt(0).toString(Yo)}`.slice(-Uo)}`;
}
s(Wo, "escape");
function De(e, t) {
  return bn.test(e) && (e = e.replace(bn, Wo)), t.stylize(`'${B(e, t.truncate - 2)}'`, "string");
}
s(De, "inspectString");

// ../node_modules/loupe/lib/symbol.js
function Fe(e) {
  return "description" in Symbol.prototype ? e.description ? `Symbol(${e.description})` : "Symbol()" : e.toString();
}
s(Fe, "inspectSymbol");

// ../node_modules/loupe/lib/promise.js
var Sn = /* @__PURE__ */ s(() => "Promise{\u2026}", "getPromiseValue");
try {
  let { getPromiseDetails: e, kPending: t, kRejected: n } = process.binding("util");
  Array.isArray(e(Promise.resolve())) && (Sn = /* @__PURE__ */ s((r, o) => {
    let [i, c] = e(r);
    return i === t ? "Promise{<pending>}" : `Promise${i === n ? "!" : ""}{${o.inspect(c, o)}}`;
  }, "getPromiseValue"));
} catch {
}
var En = Sn;

// ../node_modules/loupe/lib/object.js
function fe(e, t) {
  let n = Object.getOwnPropertyNames(e), r = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e) : [];
  if (n.length === 0 && r.length === 0)
    return "{}";
  if (t.truncate -= 4, t.seen = t.seen || [], t.seen.includes(e))
    return "[Circular]";
  t.seen.push(e);
  let o = D(n.map((l) => [l, e[l]]), t, ce), i = D(r.map((l) => [l, e[l]]), t, ce);
  t.seen.pop();
  let c = "";
  return o && i && (c = ", "), `{ ${o}${c}${i} }`;
}
s(fe, "inspectObject");

// ../node_modules/loupe/lib/class.js
var ft = typeof Symbol < "u" && Symbol.toStringTag ? Symbol.toStringTag : !1;
function mt(e, t) {
  let n = "";
  return ft && ft in e && (n = e[ft]), n = n || e.constructor.name, (!n || n === "_class") && (n = "<Anonymous Class>"), t.truncate -= n.length,
  `${n}${fe(e, t)}`;
}
s(mt, "inspectClass");

// ../node_modules/loupe/lib/arguments.js
function pt(e, t) {
  return e.length === 0 ? "Arguments[]" : (t.truncate -= 13, `Arguments[ ${D(e, t)} ]`);
}
s(pt, "inspectArguments");

// ../node_modules/loupe/lib/error.js
var Vo = [
  "stack",
  "line",
  "column",
  "name",
  "message",
  "fileName",
  "lineNumber",
  "columnNumber",
  "number",
  "description",
  "cause"
];
function gt(e, t) {
  let n = Object.getOwnPropertyNames(e).filter((c) => Vo.indexOf(c) === -1), r = e.name;
  t.truncate -= r.length;
  let o = "";
  if (typeof e.message == "string" ? o = B(e.message, t.truncate) : n.unshift("message"), o = o ? `: ${o}` : "", t.truncate -= o.length + 5,
  t.seen = t.seen || [], t.seen.includes(e))
    return "[Circular]";
  t.seen.push(e);
  let i = D(n.map((c) => [c, e[c]]), t, ce);
  return `${r}${o}${i ? ` { ${i} }` : ""}`;
}
s(gt, "inspectObject");

// ../node_modules/loupe/lib/html.js
function qo([e, t], n) {
  return n.truncate -= 3, t ? `${n.stylize(String(e), "yellow")}=${n.stylize(`"${t}"`, "string")}` : `${n.stylize(String(e), "yellow")}`;
}
s(qo, "inspectAttribute");
function je(e, t) {
  return D(e, t, ke, `
`);
}
s(je, "inspectHTMLCollection");
function ke(e, t) {
  let n = e.getAttributeNames(), r = e.tagName.toLowerCase(), o = t.stylize(`<${r}`, "special"), i = t.stylize(">", "special"), c = t.stylize(
  `</${r}>`, "special");
  t.truncate -= r.length * 2 + 5;
  let l = "";
  n.length > 0 && (l += " ", l += D(n.map((p) => [p, e.getAttribute(p)]), t, qo, " ")), t.truncate -= l.length;
  let u = t.truncate, m = je(e.children, t);
  return m && m.length > u && (m = `${se}(${e.children.length})`), `${o}${l}${i}${m}${c}`;
}
s(ke, "inspectHTML");

// ../node_modules/loupe/lib/index.js
var Ko = typeof Symbol == "function" && typeof Symbol.for == "function", ht = Ko ? Symbol.for("chai/inspect") : "@@chai/inspect", ye = !1;
try {
  let e = _n();
  ye = e.inspect ? e.inspect.custom : !1;
} catch {
  ye = !1;
}
var Tn = /* @__PURE__ */ new WeakMap(), Cn = {}, On = {
  undefined: /* @__PURE__ */ s((e, t) => t.stylize("undefined", "undefined"), "undefined"),
  null: /* @__PURE__ */ s((e, t) => t.stylize("null", "null"), "null"),
  boolean: /* @__PURE__ */ s((e, t) => t.stylize(String(e), "boolean"), "boolean"),
  Boolean: /* @__PURE__ */ s((e, t) => t.stylize(String(e), "boolean"), "Boolean"),
  number: Le,
  Number: Le,
  bigint: xe,
  BigInt: xe,
  string: De,
  String: De,
  function: Me,
  Function: Me,
  symbol: Fe,
  // A Symbol polyfill will return `Symbol` not `symbol` from typedetect
  Symbol: Fe,
  Array: st,
  Date: ct,
  Map: ut,
  Set: at,
  RegExp: lt,
  Promise: En,
  // WeakSet, WeakMap are totally opaque to us
  WeakSet: /* @__PURE__ */ s((e, t) => t.stylize("WeakSet{\u2026}", "special"), "WeakSet"),
  WeakMap: /* @__PURE__ */ s((e, t) => t.stylize("WeakMap{\u2026}", "special"), "WeakMap"),
  Arguments: pt,
  Int8Array: te,
  Uint8Array: te,
  Uint8ClampedArray: te,
  Int16Array: te,
  Uint16Array: te,
  Int32Array: te,
  Uint32Array: te,
  Float32Array: te,
  Float64Array: te,
  Generator: /* @__PURE__ */ s(() => "", "Generator"),
  DataView: /* @__PURE__ */ s(() => "", "DataView"),
  ArrayBuffer: /* @__PURE__ */ s(() => "", "ArrayBuffer"),
  Error: gt,
  HTMLCollection: je,
  NodeList: je
}, Go = /* @__PURE__ */ s((e, t, n) => ht in e && typeof e[ht] == "function" ? e[ht](t) : ye && ye in e && typeof e[ye] == "function" ? e[ye](
t.depth, t) : "inspect" in e && typeof e.inspect == "function" ? e.inspect(t.depth, t) : "constructor" in e && Tn.has(e.constructor) ? Tn.get(
e.constructor)(e, t) : Cn[n] ? Cn[n](e, t) : "", "inspectCustom"), Ho = Object.prototype.toString;
function Be(e, t = {}) {
  let n = dn(t, Be), { customInspect: r } = n, o = e === null ? "null" : typeof e;
  if (o === "object" && (o = Ho.call(e).slice(8, -1)), o in On)
    return On[o](e, n);
  if (r && e) {
    let c = Go(e, n, o);
    if (c)
      return typeof c == "string" ? c : Be(c, n);
  }
  let i = e ? Object.getPrototypeOf(e) : !1;
  return i === Object.prototype || i === null ? fe(e, n) : e && typeof HTMLElement == "function" && e instanceof HTMLElement ? ke(e, n) : "c\
onstructor" in e ? e.constructor !== Object ? mt(e, n) : fe(e, n) : e === Object(e) ? fe(e, n) : n.stylize(String(e), o);
}
s(Be, "inspect");

// ../node_modules/@vitest/utils/dist/chunk-_commonjsHelpers.js
var { AsymmetricMatcher: Xo, DOMCollection: Zo, DOMElement: Qo, Immutable: vo, ReactElement: ei, ReactTestComponent: ti } = Te, $n = [
  ti,
  ei,
  Qo,
  Zo,
  vo,
  Xo
];
function me(e, t = 10, { maxLength: n, ...r } = {}) {
  let o = n ?? 1e4, i;
  try {
    i = Z(e, {
      maxDepth: t,
      escapeString: !1,
      plugins: $n,
      ...r
    });
  } catch {
    i = Z(e, {
      callToJSON: !1,
      maxDepth: t,
      escapeString: !1,
      plugins: $n,
      ...r
    });
  }
  return i.length >= o && t > 1 ? me(e, Math.floor(Math.min(t, Number.MAX_SAFE_INTEGER) / 2), {
    maxLength: n,
    ...r
  }) : i;
}
s(me, "stringify");
var ni = /%[sdjifoOc%]/g;
function wn(...e) {
  if (typeof e[0] != "string") {
    let i = [];
    for (let c = 0; c < e.length; c++)
      i.push(Ce(e[c], {
        depth: 0,
        colors: !1
      }));
    return i.join(" ");
  }
  let t = e.length, n = 1, r = e[0], o = String(r).replace(ni, (i) => {
    if (i === "%%")
      return "%";
    if (n >= t)
      return i;
    switch (i) {
      case "%s": {
        let c = e[n++];
        return typeof c == "bigint" ? `${c.toString()}n` : typeof c == "number" && c === 0 && 1 / c < 0 ? "-0" : typeof c == "object" && c !==
        null ? typeof c.toString == "function" && c.toString !== Object.prototype.toString ? c.toString() : Ce(c, {
          depth: 0,
          colors: !1
        }) : String(c);
      }
      case "%d": {
        let c = e[n++];
        return typeof c == "bigint" ? `${c.toString()}n` : Number(c).toString();
      }
      case "%i": {
        let c = e[n++];
        return typeof c == "bigint" ? `${c.toString()}n` : Number.parseInt(String(c)).toString();
      }
      case "%f":
        return Number.parseFloat(String(e[n++])).toString();
      case "%o":
        return Ce(e[n++], {
          showHidden: !0,
          showProxy: !0
        });
      case "%O":
        return Ce(e[n++]);
      case "%c":
        return n++, "";
      case "%j":
        try {
          return JSON.stringify(e[n++]);
        } catch (c) {
          let l = c.message;
          if (l.includes("circular structure") || l.includes("cyclic structures") || l.includes("cyclic object"))
            return "[Circular]";
          throw c;
        }
      default:
        return i;
    }
  });
  for (let i = e[n]; n < t; i = e[++n])
    i === null || typeof i != "object" ? o += ` ${i}` : o += ` ${Ce(i)}`;
  return o;
}
s(wn, "format");
function Ce(e, t = {}) {
  return t.truncate === 0 && (t.truncate = Number.POSITIVE_INFINITY), Be(e, t);
}
s(Ce, "inspect");
function An(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
s(An, "getDefaultExportFromCjs");

// ../node_modules/@vitest/utils/dist/helpers.js
function ri(e) {
  return e === Object.prototype || e === Function.prototype || e === RegExp.prototype;
}
s(ri, "isFinalObj");
function ze(e) {
  return Object.prototype.toString.apply(e).slice(8, -1);
}
s(ze, "getType");
function oi(e, t) {
  let n = typeof t == "function" ? t : (r) => t.add(r);
  Object.getOwnPropertyNames(e).forEach(n), Object.getOwnPropertySymbols(e).forEach(n);
}
s(oi, "collectOwnProperties");
function dt(e) {
  let t = /* @__PURE__ */ new Set();
  return ri(e) ? [] : (oi(e, t), Array.from(t));
}
s(dt, "getOwnProperties");
var Rn = { forceWritable: !1 };
function bt(e, t = Rn) {
  return yt(e, /* @__PURE__ */ new WeakMap(), t);
}
s(bt, "deepClone");
function yt(e, t, n = Rn) {
  let r, o;
  if (t.has(e))
    return t.get(e);
  if (Array.isArray(e)) {
    for (o = Array.from({ length: r = e.length }), t.set(e, o); r--; )
      o[r] = yt(e[r], t, n);
    return o;
  }
  if (Object.prototype.toString.call(e) === "[object Object]") {
    o = Object.create(Object.getPrototypeOf(e)), t.set(e, o);
    let i = dt(e);
    for (let c of i) {
      let l = Object.getOwnPropertyDescriptor(e, c);
      if (!l)
        continue;
      let u = yt(e[c], t, n);
      n.forceWritable ? Object.defineProperty(o, c, {
        enumerable: l.enumerable,
        configurable: !0,
        writable: !0,
        value: u
      }) : "get" in l ? Object.defineProperty(o, c, {
        ...l,
        get() {
          return u;
        }
      }) : Object.defineProperty(o, c, {
        ...l,
        value: u
      });
    }
    return o;
  }
  return e;
}
s(yt, "clone");

// ../node_modules/@vitest/utils/dist/diff.js
var z = -1, j = 1, M = 0, At = class At {
  0;
  1;
  constructor(t, n) {
    this[0] = t, this[1] = n;
  }
};
s(At, "Diff");
var N = At;
function ii(e, t) {
  if (!e || !t || e.charAt(0) !== t.charAt(0))
    return 0;
  let n = 0, r = Math.min(e.length, t.length), o = r, i = 0;
  for (; n < o; )
    e.substring(i, o) === t.substring(i, o) ? (n = o, i = n) : r = o, o = Math.floor((r - n) / 2 + n);
  return o;
}
s(ii, "diff_commonPrefix");
function Vn(e, t) {
  if (!e || !t || e.charAt(e.length - 1) !== t.charAt(t.length - 1))
    return 0;
  let n = 0, r = Math.min(e.length, t.length), o = r, i = 0;
  for (; n < o; )
    e.substring(e.length - o, e.length - i) === t.substring(t.length - o, t.length - i) ? (n = o, i = n) : r = o, o = Math.floor((r - n) / 2 +
    n);
  return o;
}
s(Vn, "diff_commonSuffix");
function Nn(e, t) {
  let n = e.length, r = t.length;
  if (n === 0 || r === 0)
    return 0;
  n > r ? e = e.substring(n - r) : n < r && (t = t.substring(0, n));
  let o = Math.min(n, r);
  if (e === t)
    return o;
  let i = 0, c = 1;
  for (; ; ) {
    let l = e.substring(o - c), u = t.indexOf(l);
    if (u === -1)
      return i;
    c += u, (u === 0 || e.substring(o - c) === t.substring(0, c)) && (i = c, c++);
  }
}
s(Nn, "diff_commonOverlap_");
function si(e) {
  let t = !1, n = [], r = 0, o = null, i = 0, c = 0, l = 0, u = 0, m = 0;
  for (; i < e.length; )
    e[i][0] === M ? (n[r++] = i, c = u, l = m, u = 0, m = 0, o = e[i][1]) : (e[i][0] === j ? u += e[i][1].length : m += e[i][1].length, o &&
    o.length <= Math.max(c, l) && o.length <= Math.max(u, m) && (e.splice(n[r - 1], 0, new N(z, o)), e[n[r - 1] + 1][0] = j, r--, r--, i = r >
    0 ? n[r - 1] : -1, c = 0, l = 0, u = 0, m = 0, o = null, t = !0)), i++;
  for (t && qn(e), li(e), i = 1; i < e.length; ) {
    if (e[i - 1][0] === z && e[i][0] === j) {
      let p = e[i - 1][1], a = e[i][1], S = Nn(p, a), g = Nn(a, p);
      S >= g ? (S >= p.length / 2 || S >= a.length / 2) && (e.splice(i, 0, new N(M, a.substring(0, S))), e[i - 1][1] = p.substring(0, p.length -
      S), e[i + 1][1] = a.substring(S), i++) : (g >= p.length / 2 || g >= a.length / 2) && (e.splice(i, 0, new N(M, p.substring(0, g))), e[i -
      1][0] = j, e[i - 1][1] = a.substring(0, a.length - g), e[i + 1][0] = z, e[i + 1][1] = p.substring(g), i++), i++;
    }
    i++;
  }
}
s(si, "diff_cleanupSemantic");
var In = /[^a-z0-9]/i, Pn = /\s/, Mn = /[\r\n]/, ci = /\n\r?\n$/, ui = /^\r?\n\r?\n/;
function li(e) {
  let t = 1;
  for (; t < e.length - 1; ) {
    if (e[t - 1][0] === M && e[t + 1][0] === M) {
      let n = e[t - 1][1], r = e[t][1], o = e[t + 1][1], i = Vn(n, r);
      if (i) {
        let p = r.substring(r.length - i);
        n = n.substring(0, n.length - i), r = p + r.substring(0, r.length - i), o = p + o;
      }
      let c = n, l = r, u = o, m = Ye(n, r) + Ye(r, o);
      for (; r.charAt(0) === o.charAt(0); ) {
        n += r.charAt(0), r = r.substring(1) + o.charAt(0), o = o.substring(1);
        let p = Ye(n, r) + Ye(r, o);
        p >= m && (m = p, c = n, l = r, u = o);
      }
      e[t - 1][1] !== c && (c ? e[t - 1][1] = c : (e.splice(t - 1, 1), t--), e[t][1] = l, u ? e[t + 1][1] = u : (e.splice(t + 1, 1), t--));
    }
    t++;
  }
}
s(li, "diff_cleanupSemanticLossless");
function qn(e) {
  e.push(new N(M, ""));
  let t = 0, n = 0, r = 0, o = "", i = "", c;
  for (; t < e.length; )
    switch (e[t][0]) {
      case j:
        r++, i += e[t][1], t++;
        break;
      case z:
        n++, o += e[t][1], t++;
        break;
      case M:
        n + r > 1 ? (n !== 0 && r !== 0 && (c = ii(i, o), c !== 0 && (t - n - r > 0 && e[t - n - r - 1][0] === M ? e[t - n - r - 1][1] += i.
        substring(0, c) : (e.splice(0, 0, new N(M, i.substring(0, c))), t++), i = i.substring(c), o = o.substring(c)), c = Vn(i, o), c !== 0 &&
        (e[t][1] = i.substring(i.length - c) + e[t][1], i = i.substring(0, i.length - c), o = o.substring(0, o.length - c))), t -= n + r, e.
        splice(t, n + r), o.length && (e.splice(t, 0, new N(z, o)), t++), i.length && (e.splice(t, 0, new N(j, i)), t++), t++) : t !== 0 && e[t -
        1][0] === M ? (e[t - 1][1] += e[t][1], e.splice(t, 1)) : t++, r = 0, n = 0, o = "", i = "";
        break;
    }
  e[e.length - 1][1] === "" && e.pop();
  let l = !1;
  for (t = 1; t < e.length - 1; )
    e[t - 1][0] === M && e[t + 1][0] === M && (e[t][1].substring(e[t][1].length - e[t - 1][1].length) === e[t - 1][1] ? (e[t][1] = e[t - 1][1] +
    e[t][1].substring(0, e[t][1].length - e[t - 1][1].length), e[t + 1][1] = e[t - 1][1] + e[t + 1][1], e.splice(t - 1, 1), l = !0) : e[t][1].
    substring(0, e[t + 1][1].length) === e[t + 1][1] && (e[t - 1][1] += e[t + 1][1], e[t][1] = e[t][1].substring(e[t + 1][1].length) + e[t +
    1][1], e.splice(t + 1, 1), l = !0)), t++;
  l && qn(e);
}
s(qn, "diff_cleanupMerge");
function Ye(e, t) {
  if (!e || !t)
    return 6;
  let n = e.charAt(e.length - 1), r = t.charAt(0), o = n.match(In), i = r.match(In), c = o && n.match(Pn), l = i && r.match(Pn), u = c && n.
  match(Mn), m = l && r.match(Mn), p = u && e.match(ci), a = m && t.match(ui);
  return p || a ? 5 : u || m ? 4 : o && !c && l ? 3 : c || l ? 2 : o || i ? 1 : 0;
}
s(Ye, "diff_cleanupSemanticScore_");
var Kn = "Compared values have no visual difference.", ai = "Compared values serialize to the same structure.\nPrinting internal object struc\
ture without calling `toJSON` instead.", Ue = {}, Ln;
function fi() {
  if (Ln) return Ue;
  Ln = 1, Object.defineProperty(Ue, "__esModule", {
    value: !0
  }), Ue.default = S;
  let e = "diff-sequences", t = 0, n = /* @__PURE__ */ s((g, h, f, y, b) => {
    let _ = 0;
    for (; g < h && f < y && b(g, f); )
      g += 1, f += 1, _ += 1;
    return _;
  }, "countCommonItemsF"), r = /* @__PURE__ */ s((g, h, f, y, b) => {
    let _ = 0;
    for (; g <= h && f <= y && b(h, y); )
      h -= 1, y -= 1, _ += 1;
    return _;
  }, "countCommonItemsR"), o = /* @__PURE__ */ s((g, h, f, y, b, _, O) => {
    let d = 0, E = -g, $ = _[d], T = $;
    _[d] += n(
      $ + 1,
      h,
      y + $ - E + 1,
      f,
      b
    );
    let A = g < O ? g : O;
    for (d += 1, E += 2; d <= A; d += 1, E += 2) {
      if (d !== g && T < _[d])
        $ = _[d];
      else if ($ = T + 1, h <= $)
        return d - 1;
      T = _[d], _[d] = $ + n($ + 1, h, y + $ - E + 1, f, b);
    }
    return O;
  }, "extendPathsF"), i = /* @__PURE__ */ s((g, h, f, y, b, _, O) => {
    let d = 0, E = g, $ = _[d], T = $;
    _[d] -= r(
      h,
      $ - 1,
      f,
      y + $ - E - 1,
      b
    );
    let A = g < O ? g : O;
    for (d += 1, E -= 2; d <= A; d += 1, E -= 2) {
      if (d !== g && _[d] < T)
        $ = _[d];
      else if ($ = T - 1, $ < h)
        return d - 1;
      T = _[d], _[d] = $ - r(
        h,
        $ - 1,
        f,
        y + $ - E - 1,
        b
      );
    }
    return O;
  }, "extendPathsR"), c = /* @__PURE__ */ s((g, h, f, y, b, _, O, d, E, $, T) => {
    let A = y - h, G = f - h, P = b - y - G, k = -P - (g - 1), H = -P + (g - 1), Y = t, I = g < d ? g : d;
    for (let L = 0, x = -g; L <= I; L += 1, x += 2) {
      let J = L === 0 || L !== g && Y < O[L], F = J ? O[L] : Y, V = J ? F : F + 1, re = A + V - x, q = n(
        V + 1,
        f,
        re + 1,
        b,
        _
      ), K = V + q;
      if (Y = O[L], O[L] = K, k <= x && x <= H) {
        let ie = (g - 1 - (x + P)) / 2;
        if (ie <= $ && E[ie] - 1 <= K) {
          let X = A + F - (J ? x + 1 : x - 1), W = r(
            h,
            F,
            y,
            X,
            _
          ), oe = F - W, ge = X - W, ue = oe + 1, Se = ge + 1;
          T.nChangePreceding = g - 1, g - 1 === ue + Se - h - y ? (T.aEndPreceding = h, T.bEndPreceding = y) : (T.aEndPreceding = ue, T.bEndPreceding =
          Se), T.nCommonPreceding = W, W !== 0 && (T.aCommonPreceding = ue, T.bCommonPreceding = Se), T.nCommonFollowing = q, q !== 0 && (T.
          aCommonFollowing = V + 1, T.bCommonFollowing = re + 1);
          let Oe = K + 1, $e = re + q + 1;
          return T.nChangeFollowing = g - 1, g - 1 === f + b - Oe - $e ? (T.aStartFollowing = f, T.bStartFollowing = b) : (T.aStartFollowing =
          Oe, T.bStartFollowing = $e), !0;
        }
      }
    }
    return !1;
  }, "extendOverlappablePathsF"), l = /* @__PURE__ */ s((g, h, f, y, b, _, O, d, E, $, T) => {
    let A = b - f, G = f - h, P = b - y - G, k = P - g, H = P + g, Y = t, I = g < $ ? g : $;
    for (let L = 0, x = g; L <= I; L += 1, x -= 2) {
      let J = L === 0 || L !== g && E[L] < Y, F = J ? E[L] : Y, V = J ? F : F - 1, re = A + V - x, q = r(
        h,
        V - 1,
        y,
        re - 1,
        _
      ), K = V - q;
      if (Y = E[L], E[L] = K, k <= x && x <= H) {
        let ie = (g + (x - P)) / 2;
        if (ie <= d && K - 1 <= O[ie]) {
          let X = re - q;
          if (T.nChangePreceding = g, g === K + X - h - y ? (T.aEndPreceding = h, T.bEndPreceding = y) : (T.aEndPreceding = K, T.bEndPreceding =
          X), T.nCommonPreceding = q, q !== 0 && (T.aCommonPreceding = K, T.bCommonPreceding = X), T.nChangeFollowing = g - 1, g === 1)
            T.nCommonFollowing = 0, T.aStartFollowing = f, T.bStartFollowing = b;
          else {
            let W = A + F - (J ? x - 1 : x + 1), oe = n(
              F,
              f,
              W,
              b,
              _
            );
            T.nCommonFollowing = oe, oe !== 0 && (T.aCommonFollowing = F, T.bCommonFollowing = W);
            let ge = F + oe, ue = W + oe;
            g - 1 === f + b - ge - ue ? (T.aStartFollowing = f, T.bStartFollowing = b) : (T.aStartFollowing = ge, T.bStartFollowing = ue);
          }
          return !0;
        }
      }
    }
    return !1;
  }, "extendOverlappablePathsR"), u = /* @__PURE__ */ s((g, h, f, y, b, _, O, d, E) => {
    let $ = y - h, T = b - f, A = f - h, G = b - y, Q = G - A, P = A, k = A;
    if (O[0] = h - 1, d[0] = f, Q % 2 === 0) {
      let H = (g || Q) / 2, Y = (A + G) / 2;
      for (let I = 1; I <= Y; I += 1)
        if (P = o(I, f, b, $, _, O, P), I < H)
          k = i(I, h, y, T, _, d, k);
        else if (
          // If a reverse path overlaps a forward path in the same diagonal,
          // return a division of the index intervals at the middle change.
          l(
            I,
            h,
            f,
            y,
            b,
            _,
            O,
            P,
            d,
            k,
            E
          )
        )
          return;
    } else {
      let H = ((g || Q) + 1) / 2, Y = (A + G + 1) / 2, I = 1;
      for (P = o(I, f, b, $, _, O, P), I += 1; I <= Y; I += 1)
        if (k = i(
          I - 1,
          h,
          y,
          T,
          _,
          d,
          k
        ), I < H)
          P = o(I, f, b, $, _, O, P);
        else if (
          // If a forward path overlaps a reverse path in the same diagonal,
          // return a division of the index intervals at the middle change.
          c(
            I,
            h,
            f,
            y,
            b,
            _,
            O,
            P,
            d,
            k,
            E
          )
        )
          return;
    }
    throw new Error(
      `${e}: no overlap aStart=${h} aEnd=${f} bStart=${y} bEnd=${b}`
    );
  }, "divide"), m = /* @__PURE__ */ s((g, h, f, y, b, _, O, d, E, $) => {
    if (b - y < f - h) {
      if (_ = !_, _ && O.length === 1) {
        let { foundSubsequence: K, isCommon: ie } = O[0];
        O[1] = {
          foundSubsequence: /* @__PURE__ */ s((X, W, oe) => {
            K(X, oe, W);
          }, "foundSubsequence"),
          isCommon: /* @__PURE__ */ s((X, W) => ie(W, X), "isCommon")
        };
      }
      let re = h, q = f;
      h = y, f = b, y = re, b = q;
    }
    let { foundSubsequence: T, isCommon: A } = O[_ ? 1 : 0];
    u(
      g,
      h,
      f,
      y,
      b,
      A,
      d,
      E,
      $
    );
    let {
      nChangePreceding: G,
      aEndPreceding: Q,
      bEndPreceding: P,
      nCommonPreceding: k,
      aCommonPreceding: H,
      bCommonPreceding: Y,
      nCommonFollowing: I,
      aCommonFollowing: L,
      bCommonFollowing: x,
      nChangeFollowing: J,
      aStartFollowing: F,
      bStartFollowing: V
    } = $;
    h < Q && y < P && m(
      G,
      h,
      Q,
      y,
      P,
      _,
      O,
      d,
      E,
      $
    ), k !== 0 && T(k, H, Y), I !== 0 && T(I, L, x), F < f && V < b && m(
      J,
      F,
      f,
      V,
      b,
      _,
      O,
      d,
      E,
      $
    );
  }, "findSubsequences"), p = /* @__PURE__ */ s((g, h) => {
    if (typeof h != "number")
      throw new TypeError(`${e}: ${g} typeof ${typeof h} is not a number`);
    if (!Number.isSafeInteger(h))
      throw new RangeError(`${e}: ${g} value ${h} is not a safe integer`);
    if (h < 0)
      throw new RangeError(`${e}: ${g} value ${h} is a negative integer`);
  }, "validateLength"), a = /* @__PURE__ */ s((g, h) => {
    let f = typeof h;
    if (f !== "function")
      throw new TypeError(`${e}: ${g} typeof ${f} is not a function`);
  }, "validateCallback");
  function S(g, h, f, y) {
    p("aLength", g), p("bLength", h), a("isCommon", f), a("foundSubsequence", y);
    let b = n(0, g, 0, h, f);
    if (b !== 0 && y(b, 0, 0), g !== b || h !== b) {
      let _ = b, O = b, d = r(
        _,
        g - 1,
        O,
        h - 1,
        f
      ), E = g - d, $ = h - d, T = b + d;
      g !== T && h !== T && m(
        0,
        _,
        E,
        O,
        $,
        !1,
        [
          {
            foundSubsequence: y,
            isCommon: f
          }
        ],
        [t],
        [t],
        {
          aCommonFollowing: t,
          aCommonPreceding: t,
          aEndPreceding: t,
          aStartFollowing: t,
          bCommonFollowing: t,
          bCommonPreceding: t,
          bEndPreceding: t,
          bStartFollowing: t,
          nChangeFollowing: t,
          nChangePreceding: t,
          nCommonFollowing: t,
          nCommonPreceding: t
        }
      ), d !== 0 && y(d, E, $);
    }
  }
  return s(S, "diffSequence"), Ue;
}
s(fi, "requireBuild");
var mi = fi(), Gn = /* @__PURE__ */ An(mi);
function pi(e, t) {
  return e.replace(/\s+$/, (n) => t(n));
}
s(pi, "formatTrailingSpaces");
function $t(e, t, n, r, o, i) {
  return e.length !== 0 ? n(`${r} ${pi(e, o)}`) : r !== " " ? n(r) : t && i.length !== 0 ? n(`${r} ${i}`) : "";
}
s($t, "printDiffLine");
function Hn(e, t, { aColor: n, aIndicator: r, changeLineTrailingSpaceColor: o, emptyFirstOrLastLinePlaceholder: i }) {
  return $t(e, t, n, r, o, i);
}
s(Hn, "printDeleteLine");
function Jn(e, t, { bColor: n, bIndicator: r, changeLineTrailingSpaceColor: o, emptyFirstOrLastLinePlaceholder: i }) {
  return $t(e, t, n, r, o, i);
}
s(Jn, "printInsertLine");
function Xn(e, t, { commonColor: n, commonIndicator: r, commonLineTrailingSpaceColor: o, emptyFirstOrLastLinePlaceholder: i }) {
  return $t(e, t, n, r, o, i);
}
s(Xn, "printCommonLine");
function xn(e, t, n, r, { patchColor: o }) {
  return o(`@@ -${e + 1},${t - e} +${n + 1},${r - n} @@`);
}
s(xn, "createPatchMark");
function gi(e, t) {
  let n = e.length, r = t.contextLines, o = r + r, i = n, c = !1, l = 0, u = 0;
  for (; u !== n; ) {
    let d = u;
    for (; u !== n && e[u][0] === M; )
      u += 1;
    if (d !== u)
      if (d === 0)
        u > r && (i -= u - r, c = !0);
      else if (u === n) {
        let E = u - d;
        E > r && (i -= E - r, c = !0);
      } else {
        let E = u - d;
        E > o && (i -= E - o, l += 1);
      }
    for (; u !== n && e[u][0] !== M; )
      u += 1;
  }
  let m = l !== 0 || c;
  l !== 0 ? i += l + 1 : c && (i += 1);
  let p = i - 1, a = [], S = 0;
  m && a.push("");
  let g = 0, h = 0, f = 0, y = 0, b = /* @__PURE__ */ s((d) => {
    let E = a.length;
    a.push(Xn(d, E === 0 || E === p, t)), f += 1, y += 1;
  }, "pushCommonLine"), _ = /* @__PURE__ */ s((d) => {
    let E = a.length;
    a.push(Hn(d, E === 0 || E === p, t)), f += 1;
  }, "pushDeleteLine"), O = /* @__PURE__ */ s((d) => {
    let E = a.length;
    a.push(Jn(d, E === 0 || E === p, t)), y += 1;
  }, "pushInsertLine");
  for (u = 0; u !== n; ) {
    let d = u;
    for (; u !== n && e[u][0] === M; )
      u += 1;
    if (d !== u)
      if (d === 0) {
        u > r && (d = u - r, g = d, h = d, f = g, y = h);
        for (let E = d; E !== u; E += 1)
          b(e[E][1]);
      } else if (u === n) {
        let E = u - d > r ? d + r : u;
        for (let $ = d; $ !== E; $ += 1)
          b(e[$][1]);
      } else {
        let E = u - d;
        if (E > o) {
          let $ = d + r;
          for (let A = d; A !== $; A += 1)
            b(e[A][1]);
          a[S] = xn(g, f, h, y, t), S = a.length, a.push("");
          let T = E - o;
          g = f + T, h = y + T, f = g, y = h;
          for (let A = u - r; A !== u; A += 1)
            b(e[A][1]);
        } else
          for (let $ = d; $ !== u; $ += 1)
            b(e[$][1]);
      }
    for (; u !== n && e[u][0] === z; )
      _(e[u][1]), u += 1;
    for (; u !== n && e[u][0] === j; )
      O(e[u][1]), u += 1;
  }
  return m && (a[S] = xn(g, f, h, y, t)), a.join(`
`);
}
s(gi, "joinAlignedDiffsNoExpand");
function hi(e, t) {
  return e.map((n, r, o) => {
    let i = n[1], c = r === 0 || r === o.length - 1;
    switch (n[0]) {
      case z:
        return Hn(i, c, t);
      case j:
        return Jn(i, c, t);
      default:
        return Xn(i, c, t);
    }
  }).join(`
`);
}
s(hi, "joinAlignedDiffsExpand");
var St = /* @__PURE__ */ s((e) => e, "noColor"), Zn = 5, yi = 0;
function di() {
  return {
    aAnnotation: "Expected",
    aColor: v.green,
    aIndicator: "-",
    bAnnotation: "Received",
    bColor: v.red,
    bIndicator: "+",
    changeColor: v.inverse,
    changeLineTrailingSpaceColor: St,
    commonColor: v.dim,
    commonIndicator: " ",
    commonLineTrailingSpaceColor: St,
    compareKeys: void 0,
    contextLines: Zn,
    emptyFirstOrLastLinePlaceholder: "",
    expand: !1,
    includeChangeCounts: !1,
    omitAnnotationLines: !1,
    patchColor: v.yellow,
    printBasicPrototype: !1,
    truncateThreshold: yi,
    truncateAnnotation: "... Diff result is truncated",
    truncateAnnotationColor: St
  };
}
s(di, "getDefaultOptions");
function bi(e) {
  return e && typeof e == "function" ? e : void 0;
}
s(bi, "getCompareKeys");
function Si(e) {
  return typeof e == "number" && Number.isSafeInteger(e) && e >= 0 ? e : Zn;
}
s(Si, "getContextLines");
function pe(e = {}) {
  return {
    ...di(),
    ...e,
    compareKeys: bi(e.compareKeys),
    contextLines: Si(e.contextLines)
  };
}
s(pe, "normalizeDiffOptions");
function de(e) {
  return e.length === 1 && e[0].length === 0;
}
s(de, "isEmptyString");
function Ei(e) {
  let t = 0, n = 0;
  return e.forEach((r) => {
    switch (r[0]) {
      case z:
        t += 1;
        break;
      case j:
        n += 1;
        break;
    }
  }), {
    a: t,
    b: n
  };
}
s(Ei, "countChanges");
function _i({ aAnnotation: e, aColor: t, aIndicator: n, bAnnotation: r, bColor: o, bIndicator: i, includeChangeCounts: c, omitAnnotationLines: l }, u) {
  if (l)
    return "";
  let m = "", p = "";
  if (c) {
    let g = String(u.a), h = String(u.b), f = r.length - e.length, y = " ".repeat(Math.max(0, f)), b = " ".repeat(Math.max(0, -f)), _ = h.length -
    g.length, O = " ".repeat(Math.max(0, _)), d = " ".repeat(Math.max(0, -_));
    m = `${y}  ${n} ${O}${g}`, p = `${b}  ${i} ${d}${h}`;
  }
  let a = `${n} ${e}${m}`, S = `${i} ${r}${p}`;
  return `${t(a)}
${o(S)}

`;
}
s(_i, "printAnnotation");
function wt(e, t, n) {
  return _i(n, Ei(e)) + (n.expand ? hi(e, n) : gi(e, n)) + (t ? n.truncateAnnotationColor(`
${n.truncateAnnotation}`) : "");
}
s(wt, "printDiffLines");
function Ve(e, t, n) {
  let r = pe(n), [o, i] = Qn(de(e) ? [] : e, de(t) ? [] : t, r);
  return wt(o, i, r);
}
s(Ve, "diffLinesUnified");
function Ti(e, t, n, r, o) {
  if (de(e) && de(n) && (e = [], n = []), de(t) && de(r) && (t = [], r = []), e.length !== n.length || t.length !== r.length)
    return Ve(e, t, o);
  let [i, c] = Qn(n, r, o), l = 0, u = 0;
  return i.forEach((m) => {
    switch (m[0]) {
      case z:
        m[1] = e[l], l += 1;
        break;
      case j:
        m[1] = t[u], u += 1;
        break;
      default:
        m[1] = t[u], l += 1, u += 1;
    }
  }), wt(i, c, pe(o));
}
s(Ti, "diffLinesUnified2");
function Qn(e, t, n) {
  let r = n?.truncateThreshold ?? !1, o = Math.max(Math.floor(n?.truncateThreshold ?? 0), 0), i = r ? Math.min(e.length, o) : e.length, c = r ?
  Math.min(t.length, o) : t.length, l = i !== e.length || c !== t.length, u = /* @__PURE__ */ s((g, h) => e[g] === t[h], "isCommon"), m = [],
  p = 0, a = 0;
  for (Gn(i, c, u, /* @__PURE__ */ s((g, h, f) => {
    for (; p !== h; p += 1)
      m.push(new N(z, e[p]));
    for (; a !== f; a += 1)
      m.push(new N(j, t[a]));
    for (; g !== 0; g -= 1, p += 1, a += 1)
      m.push(new N(M, t[a]));
  }, "foundSubsequence")); p !== i; p += 1)
    m.push(new N(z, e[p]));
  for (; a !== c; a += 1)
    m.push(new N(j, t[a]));
  return [m, l];
}
s(Qn, "diffLinesRaw");
function Dn(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  if (Array.isArray(e))
    return "array";
  if (typeof e == "boolean")
    return "boolean";
  if (typeof e == "function")
    return "function";
  if (typeof e == "number")
    return "number";
  if (typeof e == "string")
    return "string";
  if (typeof e == "bigint")
    return "bigint";
  if (typeof e == "object") {
    if (e != null) {
      if (e.constructor === RegExp)
        return "regexp";
      if (e.constructor === Map)
        return "map";
      if (e.constructor === Set)
        return "set";
      if (e.constructor === Date)
        return "date";
    }
    return "object";
  } else if (typeof e == "symbol")
    return "symbol";
  throw new Error(`value of unknown type: ${e}`);
}
s(Dn, "getType");
function Fn(e) {
  return e.includes(`\r
`) ? `\r
` : `
`;
}
s(Fn, "getNewLineSymbol");
function Ci(e, t, n) {
  let r = n?.truncateThreshold ?? !1, o = Math.max(Math.floor(n?.truncateThreshold ?? 0), 0), i = e.length, c = t.length;
  if (r) {
    let g = e.includes(`
`), h = t.includes(`
`), f = Fn(e), y = Fn(t), b = g ? `${e.split(f, o).join(f)}
` : e, _ = h ? `${t.split(y, o).join(y)}
` : t;
    i = b.length, c = _.length;
  }
  let l = i !== e.length || c !== t.length, u = /* @__PURE__ */ s((g, h) => e[g] === t[h], "isCommon"), m = 0, p = 0, a = [];
  return Gn(i, c, u, /* @__PURE__ */ s((g, h, f) => {
    m !== h && a.push(new N(z, e.slice(m, h))), p !== f && a.push(new N(j, t.slice(p, f))), m = h + g, p = f + g, a.push(new N(M, t.slice(f,
    p)));
  }, "foundSubsequence")), m !== i && a.push(new N(z, e.slice(m))), p !== c && a.push(new N(j, t.slice(p))), [a, l];
}
s(Ci, "diffStrings");
function Oi(e, t, n) {
  return t.reduce((r, o) => r + (o[0] === M ? o[1] : o[0] === e && o[1].length !== 0 ? n(o[1]) : ""), "");
}
s(Oi, "concatenateRelevantDiffs");
var Rt = class Rt {
  op;
  line;
  lines;
  changeColor;
  constructor(t, n) {
    this.op = t, this.line = [], this.lines = [], this.changeColor = n;
  }
  pushSubstring(t) {
    this.pushDiff(new N(this.op, t));
  }
  pushLine() {
    this.lines.push(this.line.length !== 1 ? new N(this.op, Oi(this.op, this.line, this.changeColor)) : this.line[0][0] === this.op ? this.line[0] :
    new N(this.op, this.line[0][1])), this.line.length = 0;
  }
  isLineEmpty() {
    return this.line.length === 0;
  }
  pushDiff(t) {
    this.line.push(t);
  }
  align(t) {
    let n = t[1];
    if (n.includes(`
`)) {
      let r = n.split(`
`), o = r.length - 1;
      r.forEach((i, c) => {
        c < o ? (this.pushSubstring(i), this.pushLine()) : i.length !== 0 && this.pushSubstring(i);
      });
    } else
      this.pushDiff(t);
  }
  moveLinesTo(t) {
    this.isLineEmpty() || this.pushLine(), t.push(...this.lines), this.lines.length = 0;
  }
};
s(Rt, "ChangeBuffer");
var We = Rt, Nt = class Nt {
  deleteBuffer;
  insertBuffer;
  lines;
  constructor(t, n) {
    this.deleteBuffer = t, this.insertBuffer = n, this.lines = [];
  }
  pushDiffCommonLine(t) {
    this.lines.push(t);
  }
  pushDiffChangeLines(t) {
    let n = t[1].length === 0;
    (!n || this.deleteBuffer.isLineEmpty()) && this.deleteBuffer.pushDiff(t), (!n || this.insertBuffer.isLineEmpty()) && this.insertBuffer.pushDiff(
    t);
  }
  flushChangeLines() {
    this.deleteBuffer.moveLinesTo(this.lines), this.insertBuffer.moveLinesTo(this.lines);
  }
  align(t) {
    let n = t[0], r = t[1];
    if (r.includes(`
`)) {
      let o = r.split(`
`), i = o.length - 1;
      o.forEach((c, l) => {
        if (l === 0) {
          let u = new N(n, c);
          this.deleteBuffer.isLineEmpty() && this.insertBuffer.isLineEmpty() ? (this.flushChangeLines(), this.pushDiffCommonLine(u)) : (this.
          pushDiffChangeLines(u), this.flushChangeLines());
        } else l < i ? this.pushDiffCommonLine(new N(n, c)) : c.length !== 0 && this.pushDiffChangeLines(new N(n, c));
      });
    } else
      this.pushDiffChangeLines(t);
  }
  getLines() {
    return this.flushChangeLines(), this.lines;
  }
};
s(Nt, "CommonBuffer");
var _t = Nt;
function $i(e, t) {
  let n = new We(z, t), r = new We(j, t), o = new _t(n, r);
  return e.forEach((i) => {
    switch (i[0]) {
      case z:
        n.align(i);
        break;
      case j:
        r.align(i);
        break;
      default:
        o.align(i);
    }
  }), o.getLines();
}
s($i, "getAlignedDiffs");
function wi(e, t) {
  if (t) {
    let n = e.length - 1;
    return e.some((r, o) => r[0] === M && (o !== n || r[1] !== `
`));
  }
  return e.some((n) => n[0] === M);
}
s(wi, "hasCommonDiff");
function Ai(e, t, n) {
  if (e !== t && e.length !== 0 && t.length !== 0) {
    let r = e.includes(`
`) || t.includes(`
`), [o, i] = vn(r ? `${e}
` : e, r ? `${t}
` : t, !0, n);
    if (wi(o, r)) {
      let c = pe(n), l = $i(o, c.changeColor);
      return wt(l, i, c);
    }
  }
  return Ve(e.split(`
`), t.split(`
`), n);
}
s(Ai, "diffStringsUnified");
function vn(e, t, n, r) {
  let [o, i] = Ci(e, t, r);
  return n && si(o), [o, i];
}
s(vn, "diffStringsRaw");
function Tt(e, t) {
  let { commonColor: n } = pe(t);
  return n(e);
}
s(Tt, "getCommonMessage");
var { AsymmetricMatcher: Ri, DOMCollection: Ni, DOMElement: Ii, Immutable: Pi, ReactElement: Mi, ReactTestComponent: Li } = Te, er = [
  Li,
  Mi,
  Ii,
  Ni,
  Pi,
  Ri,
  Te.Error
], Ct = {
  maxDepth: 20,
  plugins: er
}, tr = {
  callToJSON: !1,
  maxDepth: 8,
  plugins: er
};
function xi(e, t, n) {
  if (Object.is(e, t))
    return "";
  let r = Dn(e), o = r, i = !1;
  if (r === "object" && typeof e.asymmetricMatch == "function") {
    if (e.$$typeof !== Symbol.for("jest.asymmetricMatcher") || typeof e.getExpectedType != "function")
      return;
    o = e.getExpectedType(), i = o === "string";
  }
  if (o !== Dn(t)) {
    let y = function(O) {
      return O.length <= f ? O : `${O.slice(0, f)}...`;
    };
    s(y, "truncate");
    let { aAnnotation: c, aColor: l, aIndicator: u, bAnnotation: m, bColor: p, bIndicator: a } = pe(n), S = Ot(tr, n), g = Z(e, S), h = Z(t,
    S), f = 1e5;
    g = y(g), h = y(h);
    let b = `${l(`${u} ${c}:`)} 
${g}`, _ = `${p(`${a} ${m}:`)} 
${h}`;
    return `${b}

${_}`;
  }
  if (!i)
    switch (r) {
      case "string":
        return Ve(e.split(`
`), t.split(`
`), n);
      case "boolean":
      case "number":
        return Di(e, t, n);
      case "map":
        return Et(jn(e), jn(t), n);
      case "set":
        return Et(kn(e), kn(t), n);
      default:
        return Et(e, t, n);
    }
}
s(xi, "diff");
function Di(e, t, n) {
  let r = Z(e, Ct), o = Z(t, Ct);
  return r === o ? "" : Ve(r.split(`
`), o.split(`
`), n);
}
s(Di, "comparePrimitive");
function jn(e) {
  return new Map(Array.from(e.entries()).sort());
}
s(jn, "sortMap");
function kn(e) {
  return new Set(Array.from(e.values()).sort());
}
s(kn, "sortSet");
function Et(e, t, n) {
  let r, o = !1;
  try {
    let c = Ot(Ct, n);
    r = Bn(e, t, c, n);
  } catch {
    o = !0;
  }
  let i = Tt(Kn, n);
  if (r === void 0 || r === i) {
    let c = Ot(tr, n);
    r = Bn(e, t, c, n), r !== i && !o && (r = `${Tt(ai, n)}

${r}`);
  }
  return r;
}
s(Et, "compareObjects");
function Ot(e, t) {
  let { compareKeys: n, printBasicPrototype: r, maxDepth: o } = pe(t);
  return {
    ...e,
    compareKeys: n,
    printBasicPrototype: r,
    maxDepth: o ?? e.maxDepth
  };
}
s(Ot, "getFormatOptions");
function Bn(e, t, n, r) {
  let o = {
    ...n,
    indent: 0
  }, i = Z(e, o), c = Z(t, o);
  if (i === c)
    return Tt(Kn, r);
  {
    let l = Z(e, n), u = Z(t, n);
    return Ti(l.split(`
`), u.split(`
`), i.split(`
`), c.split(`
`), r);
  }
}
s(Bn, "getObjectsDifference");
var zn = 2e4;
function Yn(e) {
  return ze(e) === "Object" && typeof e.asymmetricMatch == "function";
}
s(Yn, "isAsymmetricMatcher");
function Un(e, t) {
  let n = ze(e), r = ze(t);
  return n === r && (n === "Object" || n === "Array");
}
s(Un, "isReplaceable");
function nr(e, t, n) {
  let { aAnnotation: r, bAnnotation: o } = pe(n);
  if (typeof t == "string" && typeof e == "string" && t.length > 0 && e.length > 0 && t.length <= zn && e.length <= zn && t !== e) {
    if (t.includes(`
`) || e.includes(`
`))
      return Ai(t, e, n);
    let [p] = vn(t, e, !0), a = p.some((f) => f[0] === M), S = Fi(r, o), g = S(r) + Bi(Wn(p, z, a)), h = S(o) + ki(Wn(p, j, a));
    return `${g}
${h}`;
  }
  let i = bt(t, { forceWritable: !0 }), c = bt(e, { forceWritable: !0 }), { replacedExpected: l, replacedActual: u } = rr(c, i);
  return xi(l, u, n);
}
s(nr, "printDiffOrStringify");
function rr(e, t, n = /* @__PURE__ */ new WeakSet(), r = /* @__PURE__ */ new WeakSet()) {
  return e instanceof Error && t instanceof Error && typeof e.cause < "u" && typeof t.cause > "u" ? (delete e.cause, {
    replacedActual: e,
    replacedExpected: t
  }) : Un(e, t) ? n.has(e) || r.has(t) ? {
    replacedActual: e,
    replacedExpected: t
  } : (n.add(e), r.add(t), dt(t).forEach((o) => {
    let i = t[o], c = e[o];
    if (Yn(i))
      i.asymmetricMatch(c) && (e[o] = i);
    else if (Yn(c))
      c.asymmetricMatch(i) && (t[o] = c);
    else if (Un(c, i)) {
      let l = rr(c, i, n, r);
      e[o] = l.replacedActual, t[o] = l.replacedExpected;
    }
  }), {
    replacedActual: e,
    replacedExpected: t
  }) : {
    replacedActual: e,
    replacedExpected: t
  };
}
s(rr, "replaceAsymmetricMatcher");
function Fi(...e) {
  let t = e.reduce((n, r) => r.length > n ? r.length : n, 0);
  return (n) => `${n}: ${" ".repeat(t - n.length)}`;
}
s(Fi, "getLabelPrinter");
var ji = "\xB7";
function or(e) {
  return e.replace(/\s+$/gm, (t) => ji.repeat(t.length));
}
s(or, "replaceTrailingSpaces");
function ki(e) {
  return v.red(or(me(e)));
}
s(ki, "printReceived");
function Bi(e) {
  return v.green(or(me(e)));
}
s(Bi, "printExpected");
function Wn(e, t, n) {
  return e.reduce((r, o) => r + (o[0] === M ? o[1] : o[0] === t ? n ? v.inverse(o[1]) : o[1] : ""), "");
}
s(Wn, "getCommonAndChangedSubstrings");

// ../node_modules/@vitest/utils/dist/error.js
var zi = "@@__IMMUTABLE_RECORD__@@", Yi = "@@__IMMUTABLE_ITERABLE__@@";
function Ui(e) {
  return e && (e[Yi] || e[zi]);
}
s(Ui, "isImmutable");
var Wi = Object.getPrototypeOf({});
function ir(e) {
  return e instanceof Error ? `<unserializable>: ${e.message}` : typeof e == "string" ? `<unserializable>: ${e}` : "<unserializable>";
}
s(ir, "getUnserializableMessage");
function be(e, t = /* @__PURE__ */ new WeakMap()) {
  if (!e || typeof e == "string")
    return e;
  if (typeof e == "function")
    return `Function<${e.name || "anonymous"}>`;
  if (typeof e == "symbol")
    return e.toString();
  if (typeof e != "object")
    return e;
  if (Ui(e))
    return be(e.toJSON(), t);
  if (e instanceof Promise || e.constructor && e.constructor.prototype === "AsyncFunction")
    return "Promise";
  if (typeof Element < "u" && e instanceof Element)
    return e.tagName;
  if (typeof e.asymmetricMatch == "function")
    return `${e.toString()} ${wn(e.sample)}`;
  if (typeof e.toJSON == "function")
    return be(e.toJSON(), t);
  if (t.has(e))
    return t.get(e);
  if (Array.isArray(e)) {
    let n = new Array(e.length);
    return t.set(e, n), e.forEach((r, o) => {
      try {
        n[o] = be(r, t);
      } catch (i) {
        n[o] = ir(i);
      }
    }), n;
  } else {
    let n = /* @__PURE__ */ Object.create(null);
    t.set(e, n);
    let r = e;
    for (; r && r !== Wi; )
      Object.getOwnPropertyNames(r).forEach((o) => {
        if (!(o in n))
          try {
            n[o] = be(e[o], t);
          } catch (i) {
            delete n[o], n[o] = ir(i);
          }
      }), r = Object.getPrototypeOf(r);
    return n;
  }
}
s(be, "serializeValue");
function Vi(e) {
  return e.replace(/__(vite_ssr_import|vi_import)_\d+__\./g, "");
}
s(Vi, "normalizeErrorMessage");
function It(e, t, n = /* @__PURE__ */ new WeakSet()) {
  if (!e || typeof e != "object")
    return { message: String(e) };
  let r = e;
  r.stack && (r.stackStr = String(r.stack)), r.name && (r.nameStr = String(r.name)), (r.showDiff || r.showDiff === void 0 && r.expected !== void 0 &&
  r.actual !== void 0) && (r.diff = nr(r.actual, r.expected, {
    ...t,
    ...r.diffOptions
  })), typeof r.expected != "string" && (r.expected = me(r.expected, 10)), typeof r.actual != "string" && (r.actual = me(r.actual, 10));
  try {
    typeof r.message == "string" && (r.message = Vi(r.message));
  } catch {
  }
  try {
    !n.has(r) && typeof r.cause == "object" && (n.add(r), r.cause = It(r.cause, t, n));
  } catch {
  }
  try {
    return be(r);
  } catch (o) {
    return be(new Error(`Failed to fully serialize error: ${o?.message}
Inner error message: ${r?.message}`));
  }
}
s(It, "processError");

// src/instrumenter/EVENTS.ts
var ne = {
  CALL: "storybook/instrumenter/call",
  SYNC: "storybook/instrumenter/sync",
  START: "storybook/instrumenter/start",
  BACK: "storybook/instrumenter/back",
  GOTO: "storybook/instrumenter/goto",
  NEXT: "storybook/instrumenter/next",
  END: "storybook/instrumenter/end"
};

// src/instrumenter/preview-api.ts
var qe = globalThis.__STORYBOOK_ADDONS_PREVIEW;

// src/instrumenter/types.ts
var qi = /* @__PURE__ */ ((o) => (o.DONE = "done", o.ERROR = "error", o.ACTIVE = "active", o.WAITING = "waiting", o))(qi || {});

// src/instrumenter/instrumenter.ts
var cr = {
  start: !1,
  back: !1,
  goto: !1,
  next: !1,
  end: !1
}, Ji = new Error(
  "This function ran after the play function completed. Did you forget to `await` it?"
), ur = /* @__PURE__ */ s((e) => Object.prototype.toString.call(e) === "[object Object]", "isObject"), Xi = /* @__PURE__ */ s((e) => Object.
prototype.toString.call(e) === "[object Module]", "isModule"), Zi = /* @__PURE__ */ s((e) => {
  if (!ur(e) && !Xi(e))
    return !1;
  if (e.constructor === void 0)
    return !0;
  let t = e.constructor.prototype;
  return !!ur(t);
}, "isInstrumentable"), Qi = /* @__PURE__ */ s((e) => {
  try {
    return new e.constructor();
  } catch {
    return {};
  }
}, "construct"), Pt = /* @__PURE__ */ s(() => ({
  renderPhase: void 0,
  isDebugging: !1,
  isPlaying: !1,
  isLocked: !1,
  cursor: 0,
  calls: [],
  shadowCalls: [],
  callRefsByResult: /* @__PURE__ */ new Map(),
  chainedCallIds: /* @__PURE__ */ new Set(),
  ancestors: [],
  playUntil: void 0,
  resolvers: {},
  syncTimeout: void 0
}), "getInitialState"), lr = /* @__PURE__ */ s((e, t = !1) => {
  let n = (t ? e.shadowCalls : e.calls).filter((o) => o.retain);
  if (!n.length)
    return;
  let r = new Map(
    Array.from(e.callRefsByResult.entries()).filter(([, o]) => o.retain)
  );
  return { cursor: n.length, calls: n, callRefsByResult: r };
}, "getRetainedState"), Lt = class Lt {
  constructor() {
    this.initialized = !1;
    this.state = U.window?.parent?.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER_STATE__ || {};
    let t = /* @__PURE__ */ s(({
      storyId: u,
      isPlaying: m = !0,
      isDebugging: p = !1
    }) => {
      let a = this.getState(u);
      this.setState(u, {
        ...Pt(),
        ...lr(a, p),
        shadowCalls: p ? a.shadowCalls : [],
        chainedCallIds: p ? a.chainedCallIds : /* @__PURE__ */ new Set(),
        playUntil: p ? a.playUntil : void 0,
        isPlaying: m,
        isDebugging: p
      }), this.sync(u);
    }, "resetState"), n = /* @__PURE__ */ s((u) => ({ storyId: m, playUntil: p }) => {
      this.getState(m).isDebugging || this.setState(m, ({ calls: S }) => ({
        calls: [],
        shadowCalls: S.map((g) => ({ ...g, status: "waiting" })),
        isDebugging: !0
      }));
      let a = this.getLog(m);
      this.setState(m, ({ shadowCalls: S }) => {
        if (p || !a.length)
          return { playUntil: p };
        let g = S.findIndex((h) => h.id === a[0].callId);
        return {
          playUntil: S.slice(0, g).filter((h) => h.interceptable && !h.ancestors?.length).slice(-1)[0]?.id
        };
      }), u.emit(sr, { storyId: m, isDebugging: !0 });
    }, "start"), r = /* @__PURE__ */ s((u) => ({ storyId: m }) => {
      let p = this.getLog(m).filter((S) => !S.ancestors?.length), a = p.reduceRight((S, g, h) => S >= 0 || g.status === "waiting" ? S : h, -1);
      n(u)({ storyId: m, playUntil: p[a - 1]?.callId });
    }, "back"), o = /* @__PURE__ */ s((u) => ({ storyId: m, callId: p }) => {
      let { calls: a, shadowCalls: S, resolvers: g } = this.getState(m), h = a.find(({ id: y }) => y === p), f = S.find(({ id: y }) => y ===
      p);
      if (!h && f && Object.values(g).length > 0) {
        let y = this.getLog(m).find((b) => b.status === "waiting")?.callId;
        f.id !== y && this.setState(m, { playUntil: f.id }), Object.values(g).forEach((b) => b());
      } else
        n(u)({ storyId: m, playUntil: p });
    }, "goto"), i = /* @__PURE__ */ s((u) => ({ storyId: m }) => {
      let { resolvers: p } = this.getState(m);
      if (Object.values(p).length > 0)
        Object.values(p).forEach((a) => a());
      else {
        let a = this.getLog(m).find((S) => S.status === "waiting")?.callId;
        a ? n(u)({ storyId: m, playUntil: a }) : c({ storyId: m });
      }
    }, "next"), c = /* @__PURE__ */ s(({ storyId: u }) => {
      this.setState(u, { playUntil: void 0, isDebugging: !1 }), Object.values(this.getState(u).resolvers).forEach((m) => m());
    }, "end"), l = /* @__PURE__ */ s(({ storyId: u, newPhase: m }) => {
      let { isDebugging: p } = this.getState(u);
      this.setState(u, { renderPhase: m }), m === "preparing" && p && t({ storyId: u }), m === "playing" && t({ storyId: u, isDebugging: p }),
      m === "played" && this.setState(u, {
        isLocked: !1,
        isPlaying: !1,
        isDebugging: !1
      }), m === "errored" && this.setState(u, {
        isLocked: !1,
        isPlaying: !1
      });
    }, "renderPhaseChanged");
    qe && qe.ready().then(() => {
      this.channel = qe.getChannel(), this.channel.on(sr, t), this.channel.on(Hi, l), this.channel.on(Gi, () => {
        this.initialized ? this.cleanup() : this.initialized = !0;
      }), this.channel.on(ne.START, n(this.channel)), this.channel.on(ne.BACK, r(this.channel)), this.channel.on(ne.GOTO, o(this.channel)), this.
      channel.on(ne.NEXT, i(this.channel)), this.channel.on(ne.END, c);
    });
  }
  getState(t) {
    return this.state[t] || Pt();
  }
  setState(t, n) {
    let r = this.getState(t), o = typeof n == "function" ? n(r) : n;
    this.state = { ...this.state, [t]: { ...r, ...o } }, U.window?.parent && (U.window.parent.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER_STATE__ =
    this.state);
  }
  cleanup() {
    this.state = Object.entries(this.state).reduce(
      (n, [r, o]) => {
        let i = lr(o);
        return i && (n[r] = Object.assign(Pt(), i)), n;
      },
      {}
    );
    let t = { controlStates: cr, logItems: [] };
    this.channel?.emit(ne.SYNC, t), U.window?.parent && (U.window.parent.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER_STATE__ = this.state);
  }
  getLog(t) {
    let { calls: n, shadowCalls: r } = this.getState(t), o = [...r];
    n.forEach((c, l) => {
      o[l] = c;
    });
    let i = /* @__PURE__ */ new Set();
    return o.reduceRight((c, l) => (l.args.forEach((u) => {
      u?.__callId__ && i.add(u.__callId__);
    }), l.path.forEach((u) => {
      u.__callId__ && i.add(u.__callId__);
    }), (l.interceptable || l.exception) && !i.has(l.id) && (c.unshift({ callId: l.id, status: l.status, ancestors: l.ancestors }), i.add(l.
    id)), c), []);
  }
  // Traverses the object structure to recursively patch all function properties.
  // Returns the original object, or a new object with the same constructor,
  // depending on whether it should mutate.
  instrument(t, n, r = 0) {
    if (!Zi(t))
      return t;
    let { mutate: o = !1, path: i = [] } = n, c = n.getKeys ? n.getKeys(t, r) : Object.keys(t);
    return r += 1, c.reduce(
      (l, u) => {
        let m = es(t, u);
        if (typeof m?.get == "function") {
          if (m.configurable) {
            let a = /* @__PURE__ */ s(() => m?.get?.bind(t)?.(), "getter");
            Object.defineProperty(l, u, {
              get: /* @__PURE__ */ s(() => this.instrument(a(), { ...n, path: i.concat(u) }, r), "get")
            });
          }
          return l;
        }
        let p = t[u];
        return typeof p != "function" ? (l[u] = this.instrument(p, { ...n, path: i.concat(u) }, r), l) : "__originalFn__" in p && typeof p.__originalFn__ ==
        "function" ? (l[u] = p, l) : (l[u] = (...a) => this.track(u, p, t, a, n), l[u].__originalFn__ = p, Object.defineProperty(l[u], "name",
        { value: u, writable: !1 }), Object.keys(p).length > 0 && Object.assign(
          l[u],
          this.instrument({ ...p }, { ...n, path: i.concat(u) }, r)
        ), l);
      },
      o ? t : Qi(t)
    );
  }
  // Monkey patch an object method to record calls.
  // Returns a function that invokes the original function, records the invocation ("call") and
  // returns the original result.
  track(t, n, r, o, i) {
    let c = o?.[0]?.__storyId__ || U.__STORYBOOK_PREVIEW__?.selectionStore?.selection?.storyId, { cursor: l, ancestors: u } = this.getState(
    c);
    this.setState(c, { cursor: l + 1 });
    let m = `${u.slice(-1)[0] || c} [${l}] ${t}`, { path: p = [], intercept: a = !1, retain: S = !1 } = i, g = typeof a == "function" ? a(t,
    p) : a, h = { id: m, cursor: l, storyId: c, ancestors: u, path: p, method: t, args: o, interceptable: g, retain: S }, y = (g && !u.length ?
    this.intercept : this.invoke).call(this, n, r, h, i);
    return this.instrument(y, { ...i, mutate: !0, path: [{ __callId__: h.id }] });
  }
  intercept(t, n, r, o) {
    let { chainedCallIds: i, isDebugging: c, playUntil: l } = this.getState(r.storyId), u = i.has(r.id);
    return !c || u || l ? (l === r.id && this.setState(r.storyId, { playUntil: void 0 }), this.invoke(t, n, r, o)) : new Promise((m) => {
      this.setState(r.storyId, ({ resolvers: p }) => ({
        isLocked: !1,
        resolvers: { ...p, [r.id]: m }
      }));
    }).then(() => (this.setState(r.storyId, (m) => {
      let { [r.id]: p, ...a } = m.resolvers;
      return { isLocked: !0, resolvers: a };
    }), this.invoke(t, n, r, o)));
  }
  invoke(t, n, r, o) {
    let { callRefsByResult: i, renderPhase: c } = this.getState(r.storyId), l = 25, u = /* @__PURE__ */ s((a, S, g) => {
      if (g.includes(a))
        return "[Circular]";
      if (g = [...g, a], S > l)
        return "...";
      if (i.has(a))
        return i.get(a);
      if (a instanceof Array)
        return a.map((h) => u(h, ++S, g));
      if (a instanceof Date)
        return { __date__: { value: a.toISOString() } };
      if (a instanceof Error) {
        let { name: h, message: f, stack: y } = a;
        return { __error__: { name: h, message: f, stack: y } };
      }
      if (a instanceof RegExp) {
        let { flags: h, source: f } = a;
        return { __regexp__: { flags: h, source: f } };
      }
      if (a instanceof U.window?.HTMLElement) {
        let { prefix: h, localName: f, id: y, classList: b, innerText: _ } = a, O = Array.from(b);
        return { __element__: { prefix: h, localName: f, id: y, classNames: O, innerText: _ } };
      }
      return typeof a == "function" ? {
        __function__: { name: "getMockName" in a ? a.getMockName() : a.name }
      } : typeof a == "symbol" ? { __symbol__: { description: a.description } } : typeof a == "object" && a?.constructor?.name && a?.constructor?.
      name !== "Object" ? { __class__: { name: a.constructor.name } } : Object.prototype.toString.call(a) === "[object Object]" ? Object.fromEntries(
        Object.entries(a).map(([h, f]) => [h, u(f, ++S, g)])
      ) : a;
    }, "serializeValues"), m = {
      ...r,
      args: r.args.map((a) => u(a, 0, []))
    };
    r.path.forEach((a) => {
      a?.__callId__ && this.setState(r.storyId, ({ chainedCallIds: S }) => ({
        chainedCallIds: new Set(Array.from(S).concat(a.__callId__))
      }));
    });
    let p = /* @__PURE__ */ s((a) => {
      if (a instanceof Error) {
        let { name: S, message: g, stack: h, callId: f = r.id } = a, {
          showDiff: y = void 0,
          diff: b = void 0,
          actual: _ = void 0,
          expected: O = void 0
        } = a.name === "AssertionError" ? It(a) : a, d = { name: S, message: g, stack: h, callId: f, showDiff: y, diff: b, actual: _, expected: O };
        if (this.update({ ...m, status: "error", exception: d }), this.setState(r.storyId, (E) => ({
          callRefsByResult: new Map([
            ...Array.from(E.callRefsByResult.entries()),
            [a, { __callId__: r.id, retain: r.retain }]
          ])
        })), r.ancestors?.length)
          throw Object.prototype.hasOwnProperty.call(a, "callId") || Object.defineProperty(a, "callId", { value: r.id }), a;
      }
      throw a;
    }, "handleException");
    try {
      if (c === "played" && !r.retain)
        throw Ji;
      let S = (o.getArgs ? o.getArgs(r, this.getState(r.storyId)) : r.args).map((h) => typeof h != "function" || ts(h) || Object.keys(h).length ?
      h : (...f) => {
        let { cursor: y, ancestors: b } = this.getState(r.storyId);
        this.setState(r.storyId, { cursor: 0, ancestors: [...b, r.id] });
        let _ = /* @__PURE__ */ s(() => this.setState(r.storyId, { cursor: y, ancestors: b }), "restore"), O = !1;
        try {
          let d = h(...f);
          return d instanceof Promise ? (O = !0, d.finally(_)) : d;
        } finally {
          O || _();
        }
      }), g = t.apply(n, S);
      return g && ["object", "function", "symbol"].includes(typeof g) && this.setState(r.storyId, (h) => ({
        callRefsByResult: new Map([
          ...Array.from(h.callRefsByResult.entries()),
          [g, { __callId__: r.id, retain: r.retain }]
        ])
      })), this.update({
        ...m,
        status: g instanceof Promise ? "active" : "done"
      }), g instanceof Promise ? g.then((h) => (this.update({ ...m, status: "done" }), h), p) : g;
    } catch (a) {
      return p(a);
    }
  }
  // Sends the call info to the manager and synchronizes the log.
  update(t) {
    this.channel?.emit(ne.CALL, t), this.setState(t.storyId, ({ calls: n }) => {
      let r = n.concat(t).reduce((o, i) => Object.assign(o, { [i.id]: i }), {});
      return {
        // Calls are sorted to ensure parent calls always come before calls in their callback.
        calls: Object.values(r).sort(
          (o, i) => o.id.localeCompare(i.id, void 0, { numeric: !0 })
        )
      };
    }), this.sync(t.storyId);
  }
  // Builds a log of interceptable calls and control states and sends it to the manager.
  // Uses a 0ms debounce because this might get called many times in one tick.
  sync(t) {
    let n = /* @__PURE__ */ s(() => {
      let { isLocked: r, isPlaying: o } = this.getState(t), i = this.getLog(t), c = i.filter(({ ancestors: a }) => !a.length).find((a) => a.
      status === "waiting")?.callId, l = i.some((a) => a.status === "active");
      if (r || l || i.length === 0) {
        let a = { controlStates: cr, logItems: i };
        this.channel?.emit(ne.SYNC, a);
        return;
      }
      let u = i.some(
        (a) => a.status === "done" || a.status === "error"
      ), p = { controlStates: {
        start: u,
        back: u,
        goto: !0,
        next: o,
        end: o
      }, logItems: i, pausedAt: c };
      this.channel?.emit(ne.SYNC, p);
    }, "synchronize");
    this.setState(t, ({ syncTimeout: r }) => (clearTimeout(r), { syncTimeout: setTimeout(n, 0) }));
  }
};
s(Lt, "Instrumenter");
var Mt = Lt;
function vi(e, t = {}) {
  try {
    let n = !1, r = !1;
    return U.window?.location?.search?.includes("instrument=true") ? n = !0 : U.window?.location?.search?.includes("instrument=false") && (r =
    !0), U.window?.parent === U.window && !n || r ? e : (U.window && !U.window.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER__ && (U.window.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER__ =
    new Mt()), (U.window?.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER__).instrument(e, t));
  } catch (n) {
    return Ki.warn(n), e;
  }
}
s(vi, "instrument");
function es(e, t) {
  let n = e;
  for (; n != null; ) {
    let r = Object.getOwnPropertyDescriptor(n, t);
    if (r)
      return r;
    n = Object.getPrototypeOf(n);
  }
}
s(es, "getPropertyDescriptor");
function ts(e) {
  if (typeof e != "function")
    return !1;
  let t = Object.getOwnPropertyDescriptor(e, "prototype");
  return t ? !t.writable : !1;
}
s(ts, "isClass");
export {
  qi as CallStates,
  ne as EVENTS,
  vi as instrument
};
